{
  "version": 5,
  "gridPx": 8,
  "materialProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026",
  "generator": "scripts/build-pixel-city-pack.py",
  "runtimeAI": false,
  "terrain": {
    "GRASS": [
      "terrain/grass-0.png",
      "terrain/grass-1.png",
      "terrain/grass-2.png"
    ],
    "MEADOW": [
      "terrain/meadow-0.png",
      "terrain/meadow-1.png",
      "terrain/meadow-2.png"
    ],
    "FOREST": [
      "terrain/forest-0.png",
      "terrain/forest-1.png",
      "terrain/forest-2.png"
    ],
    "HILL": [
      "terrain/hill-0.png",
      "terrain/hill-1.png",
      "terrain/hill-2.png"
    ],
    "MOUNTAIN": [
      "terrain/mountain-0.png",
      "terrain/mountain-1.png",
      "terrain/mountain-2.png"
    ],
    "SAND": [
      "terrain/sand-0.png",
      "terrain/sand-1.png",
      "terrain/sand-2.png"
    ],
    "WET_SAND": [
      "terrain/wet_sand-0.png",
      "terrain/wet_sand-1.png",
      "terrain/wet_sand-2.png"
    ],
    "CLAY": [
      "terrain/clay-0.png",
      "terrain/clay-1.png",
      "terrain/clay-2.png"
    ],
    "STONE": [
      "terrain/stone-0.png",
      "terrain/stone-1.png",
      "terrain/stone-2.png"
    ],
    "SHALLOW_WATER": [
      "terrain/shallow_water-0.png",
      "terrain/shallow_water-1.png",
      "terrain/shallow_water-2.png",
      "terrain/shallow_water-3.png",
      "terrain/shallow_water-4.png"
    ],
    "DEEP_WATER": [
      "terrain/deep_water-0.png",
      "terrain/deep_water-1.png",
      "terrain/deep_water-2.png",
      "terrain/deep_water-3.png",
      "terrain/deep_water-4.png"
    ],
    "DIRT": [
      "terrain/dirt-0.png",
      "terrain/dirt-1.png",
      "terrain/dirt-2.png"
    ]
  },
  "transitions": {
    "shore": {
      "N": "transitions/shore-n.png",
      "E": "transitions/shore-e.png",
      "S": "transitions/shore-s.png",
      "W": "transitions/shore-w.png"
    },
    "wet-shore": {
      "N": "transitions/wet-shore-n.png",
      "E": "transitions/wet-shore-e.png",
      "S": "transitions/wet-shore-s.png",
      "W": "transitions/wet-shore-w.png"
    },
    "stone": {
      "N": "transitions/stone-n.png",
      "E": "transitions/stone-e.png",
      "S": "transitions/stone-s.png",
      "W": "transitions/stone-w.png"
    }
  },
  "tiles": {
    "grass": {
      "path": "tiles/grass.png",
      "size": [
        8,
        8
      ],
      "overlay": false,
      "materialRole": "GROUND",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "water": {
      "path": "tiles/water.png",
      "size": [
        8,
        8
      ],
      "overlay": false,
      "materialRole": "GROUND",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-foundation-a": {
      "path": "tiles/compact-construction-foundation-a.png",
      "size": [
        8,
        8
      ],
      "overlay": false,
      "materialRole": "CONSTRUCTION",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-foundation-b": {
      "path": "tiles/compact-construction-foundation-b.png",
      "size": [
        8,
        8
      ],
      "overlay": false,
      "materialRole": "CONSTRUCTION",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-foundation-c": {
      "path": "tiles/compact-construction-foundation-c.png",
      "size": [
        8,
        8
      ],
      "overlay": false,
      "materialRole": "CONSTRUCTION",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-fence": {
      "path": "tiles/compact-construction-fence.png",
      "size": [
        8,
        8
      ],
      "overlay": true,
      "materialRole": "CONSTRUCTION_OVERLAY",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-fence-corner": {
      "path": "tiles/compact-construction-fence-corner.png",
      "size": [
        8,
        8
      ],
      "overlay": true,
      "materialRole": "CONSTRUCTION_OVERLAY",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-fence-post": {
      "path": "tiles/compact-construction-fence-post.png",
      "size": [
        8,
        8
      ],
      "overlay": true,
      "materialRole": "CONSTRUCTION_OVERLAY",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    },
    "compact-construction-gate": {
      "path": "tiles/compact-construction-gate.png",
      "size": [
        8,
        8
      ],
      "overlay": true,
      "materialRole": "CONSTRUCTION_OVERLAY",
      "visualProfile": "TASKTOPIA_V5_CITY_MATERIALS_2026"
    }
  },
  "blockSurfaces": {
    "schemaVersion": 1,
    "cellPx": 4,
    "visualProfile": "TASKTOPIA_BLOCK_V1_MICRO_SURFACES_2026",
    "tiles": {
      "block-lawn": {
        "path": "block-surfaces/block-lawn.png",
        "size": [
          4,
          4
        ],
        "opaque": true,
        "materialRole": "LAWN"
      },
      "block-water": {
        "path": "block-surfaces/block-water.png",
        "size": [
          4,
          4
        ],
        "opaque": true,
        "materialRole": "WATER"
      }
    }
  },
  "buildings": {
    "compact-copper-court-v1": {
      "label": "Кирпичный дом с оливковой крышей",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-copper-court-v1/stage-1.png",
        "buildings/house/compact-copper-court-v1/stage-2.png",
        "buildings/house/compact-copper-court-v1/stage-3.png",
        "buildings/house/compact-copper-court-v1/stage-4.png",
        "buildings/house/compact-copper-court-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          6,
          47,
          48
        ],
        [
          0,
          0,
          47,
          48
        ],
        [
          0,
          0,
          47,
          48
        ]
      ]
    },
    "compact-blue-bay-v1": {
      "label": "Синий дом с балконами и террасой",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-blue-bay-v1/stage-1.png",
        "buildings/house/compact-blue-bay-v1/stage-2.png",
        "buildings/house/compact-blue-bay-v1/stage-3.png",
        "buildings/house/compact-blue-bay-v1/stage-4.png",
        "buildings/house/compact-blue-bay-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          5,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ]
      ]
    },
    "compact-apartment-v1": {
      "label": "Компактный жилой корпус",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-apartment-v1/stage-1.png",
        "buildings/house/compact-apartment-v1/stage-2.png",
        "buildings/house/compact-apartment-v1/stage-3.png",
        "buildings/house/compact-apartment-v1/stage-4.png",
        "buildings/house/compact-apartment-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          7,
          47,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ]
      ]
    },
    "compact-row-v1": {
      "label": "Низкий рядный дом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        24
      ],
      "footprintCells": [
        6,
        3
      ],
      "anchorPx": [
        24,
        24
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/house/compact-row-v1/stage-1.png",
        "buildings/house/compact-row-v1/stage-2.png",
        "buildings/house/compact-row-v1/stage-3.png",
        "buildings/house/compact-row-v1/stage-4.png",
        "buildings/house/compact-row-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          4,
          0,
          43,
          24
        ],
        [
          4,
          0,
          43,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ]
      ]
    },
    "compact-wide-v1": {
      "label": "Широкий двухэтажный дом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-wide-v1/stage-1.png",
        "buildings/house/compact-wide-v1/stage-2.png",
        "buildings/house/compact-wide-v1/stage-3.png",
        "buildings/house/compact-wide-v1/stage-4.png",
        "buildings/house/compact-wide-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-fire-station-v1": {
      "label": "Компактная пожарная станция",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "civic",
        "fire-station",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "FIRE",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-fire-station-v1/stage-1.png",
        "buildings/civic/compact-fire-station-v1/stage-2.png",
        "buildings/civic/compact-fire-station-v1/stage-3.png",
        "buildings/civic/compact-fire-station-v1/stage-4.png",
        "buildings/civic/compact-fire-station-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-clinic-v1": {
      "label": "Компактная клиника",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "civic",
        "clinic",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "MEDICAL",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-clinic-v1/stage-1.png",
        "buildings/civic/compact-clinic-v1/stage-2.png",
        "buildings/civic/compact-clinic-v1/stage-3.png",
        "buildings/civic/compact-clinic-v1/stage-4.png",
        "buildings/civic/compact-clinic-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          2,
          0,
          47,
          32
        ],
        [
          2,
          1,
          46,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-roofgarden-v1": {
      "label": "Дом с садом на крыше",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-roofgarden-v1/stage-1.png",
        "buildings/house/compact-roofgarden-v1/stage-2.png",
        "buildings/house/compact-roofgarden-v1/stage-3.png",
        "buildings/house/compact-roofgarden-v1/stage-4.png",
        "buildings/house/compact-roofgarden-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          2,
          0,
          46,
          32
        ],
        [
          2,
          0,
          46,
          32
        ],
        [
          2,
          0,
          46,
          32
        ]
      ]
    },
    "compact-bungalow-v1": {
      "label": "Длинный дом с навесом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        24
      ],
      "footprintCells": [
        6,
        3
      ],
      "anchorPx": [
        24,
        24
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/house/compact-bungalow-v1/stage-1.png",
        "buildings/house/compact-bungalow-v1/stage-2.png",
        "buildings/house/compact-bungalow-v1/stage-3.png",
        "buildings/house/compact-bungalow-v1/stage-4.png",
        "buildings/house/compact-bungalow-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          4,
          0,
          43,
          24
        ],
        [
          4,
          0,
          43,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ]
      ]
    },
    "compact-workshop-home-v1": {
      "label": "Дом-мастерская",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        24
      ],
      "footprintCells": [
        6,
        3
      ],
      "anchorPx": [
        24,
        24
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/house/compact-workshop-home-v1/stage-1.png",
        "buildings/house/compact-workshop-home-v1/stage-2.png",
        "buildings/house/compact-workshop-home-v1/stage-3.png",
        "buildings/house/compact-workshop-home-v1/stage-4.png",
        "buildings/house/compact-workshop-home-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          4,
          0,
          43,
          24
        ],
        [
          4,
          0,
          43,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ]
      ]
    },
    "compact-terrace-v1": {
      "label": "Дом с терракотовой террасой",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        24
      ],
      "footprintCells": [
        6,
        3
      ],
      "anchorPx": [
        24,
        24
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/house/compact-terrace-v1/stage-1.png",
        "buildings/house/compact-terrace-v1/stage-2.png",
        "buildings/house/compact-terrace-v1/stage-3.png",
        "buildings/house/compact-terrace-v1/stage-4.png",
        "buildings/house/compact-terrace-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          4,
          0,
          43,
          24
        ],
        [
          4,
          0,
          43,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ]
      ]
    },
    "compact-glass-stair-v1": {
      "label": "Дом со стеклянной лестницей",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-glass-stair-v1/stage-1.png",
        "buildings/house/compact-glass-stair-v1/stage-2.png",
        "buildings/house/compact-glass-stair-v1/stage-3.png",
        "buildings/house/compact-glass-stair-v1/stage-4.png",
        "buildings/house/compact-glass-stair-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          0,
          47,
          32
        ],
        [
          0,
          0,
          47,
          32
        ],
        [
          0,
          0,
          47,
          32
        ]
      ]
    },
    "compact-corner-balcony-v1": {
      "label": "Дом с угловой террасой",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-corner-balcony-v1/stage-1.png",
        "buildings/house/compact-corner-balcony-v1/stage-2.png",
        "buildings/house/compact-corner-balcony-v1/stage-3.png",
        "buildings/house/compact-corner-balcony-v1/stage-4.png",
        "buildings/house/compact-corner-balcony-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-stepped-apartment-v1": {
      "label": "Ступенчатый жилой корпус",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 3,
      "stages": [
        "buildings/house/compact-stepped-apartment-v1/stage-1.png",
        "buildings/house/compact-stepped-apartment-v1/stage-2.png",
        "buildings/house/compact-stepped-apartment-v1/stage-3.png",
        "buildings/house/compact-stepped-apartment-v1/stage-4.png",
        "buildings/house/compact-stepped-apartment-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          1,
          48,
          48
        ],
        [
          0,
          1,
          48,
          48
        ],
        [
          0,
          1,
          48,
          48
        ]
      ]
    },
    "compact-courtyard-apartment-v1": {
      "label": "Жилой дом с внутренним двориком",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 3,
      "stages": [
        "buildings/house/compact-courtyard-apartment-v1/stage-1.png",
        "buildings/house/compact-courtyard-apartment-v1/stage-2.png",
        "buildings/house/compact-courtyard-apartment-v1/stage-3.png",
        "buildings/house/compact-courtyard-apartment-v1/stage-4.png",
        "buildings/house/compact-courtyard-apartment-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ]
      ]
    },
    "compact-gabled-apartment-v1": {
      "label": "Кирпичный дом с мансардой",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 3,
      "stages": [
        "buildings/house/compact-gabled-apartment-v1/stage-1.png",
        "buildings/house/compact-gabled-apartment-v1/stage-2.png",
        "buildings/house/compact-gabled-apartment-v1/stage-3.png",
        "buildings/house/compact-gabled-apartment-v1/stage-4.png",
        "buildings/house/compact-gabled-apartment-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ]
      ]
    },
    "compact-paired-townhouse-v1": {
      "label": "Парный дом с балконом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-paired-townhouse-v1/stage-1.png",
        "buildings/house/compact-paired-townhouse-v1/stage-2.png",
        "buildings/house/compact-paired-townhouse-v1/stage-3.png",
        "buildings/house/compact-paired-townhouse-v1/stage-4.png",
        "buildings/house/compact-paired-townhouse-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          2,
          48,
          32
        ],
        [
          0,
          2,
          48,
          32
        ],
        [
          0,
          2,
          48,
          32
        ]
      ]
    },
    "compact-police-v1": {
      "label": "Участок полиции",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "police"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "POLICE",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-police-v1/stage-1.png",
        "buildings/civic/compact-police-v1/stage-2.png",
        "buildings/civic/compact-police-v1/stage-3.png",
        "buildings/civic/compact-police-v1/stage-4.png",
        "buildings/civic/compact-police-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          2,
          1,
          46,
          32
        ],
        [
          2,
          0,
          46,
          32
        ],
        [
          2,
          0,
          46,
          32
        ]
      ]
    },
    "compact-school-v1": {
      "label": "Школа",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "education"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "EDUCATION",
      "floorCount": 2,
      "educationKind": "SCHOOL",
      "stages": [
        "buildings/civic/compact-school-v1/stage-1.png",
        "buildings/civic/compact-school-v1/stage-2.png",
        "buildings/civic/compact-school-v1/stage-3.png",
        "buildings/civic/compact-school-v1/stage-4.png",
        "buildings/civic/compact-school-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          4,
          48,
          32
        ],
        [
          0,
          4,
          48,
          32
        ],
        [
          0,
          4,
          48,
          32
        ]
      ]
    },
    "compact-shop-v1": {
      "label": "Магазин у дома",
      "category": "COMMERCIAL",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "shop"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "SHOP",
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-shop-v1/stage-1.png",
        "buildings/commercial/compact-shop-v1/stage-2.png",
        "buildings/commercial/compact-shop-v1/stage-3.png",
        "buildings/commercial/compact-shop-v1/stage-4.png",
        "buildings/commercial/compact-shop-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          5,
          48,
          32
        ],
        [
          0,
          5,
          48,
          32
        ],
        [
          0,
          5,
          48,
          32
        ]
      ]
    },
    "compact-railway-v1": {
      "label": "Железнодорожный вокзал",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "railway"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "RAILWAY",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-railway-v1/stage-1.png",
        "buildings/civic/compact-railway-v1/stage-2.png",
        "buildings/civic/compact-railway-v1/stage-3.png",
        "buildings/civic/compact-railway-v1/stage-4.png",
        "buildings/civic/compact-railway-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-airport-v1": {
      "label": "Аэровокзал",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "airport"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "AIRPORT",
      "floorCount": 1,
      "stages": [
        "buildings/civic/compact-airport-v1/stage-1.png",
        "buildings/civic/compact-airport-v1/stage-2.png",
        "buildings/civic/compact-airport-v1/stage-3.png",
        "buildings/civic/compact-airport-v1/stage-4.png",
        "buildings/civic/compact-airport-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          1,
          48,
          32
        ],
        [
          0,
          1,
          48,
          32
        ],
        [
          0,
          1,
          48,
          32
        ]
      ]
    },
    "compact-civic-v1": {
      "label": "Администрация города",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "civic"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "CIVIC",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-civic-v1/stage-1.png",
        "buildings/civic/compact-civic-v1/stage-2.png",
        "buildings/civic/compact-civic-v1/stage-3.png",
        "buildings/civic/compact-civic-v1/stage-4.png",
        "buildings/civic/compact-civic-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          2,
          48,
          32
        ],
        [
          0,
          2,
          48,
          32
        ],
        [
          0,
          2,
          48,
          32
        ]
      ]
    },
    "compact-long-gallery-v1": {
      "label": "Длинный жилой корпус с галереей",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "long-gallery"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-long-gallery-v1/stage-1.png",
        "buildings/house/compact-long-gallery-v1/stage-2.png",
        "buildings/house/compact-long-gallery-v1/stage-3.png",
        "buildings/house/compact-long-gallery-v1/stage-4.png",
        "buildings/house/compact-long-gallery-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ]
      ]
    },
    "compact-ivory-library-v1": {
      "label": "Светлый дом с библиотекой",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-ivory-library-v1/stage-1.png",
        "buildings/house/compact-ivory-library-v1/stage-2.png",
        "buildings/house/compact-ivory-library-v1/stage-3.png",
        "buildings/house/compact-ivory-library-v1/stage-4.png",
        "buildings/house/compact-ivory-library-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          6,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ]
      ]
    },
    "compact-corner-court-v1": {
      "label": "Угловой дом с внутренним двором",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "corner-court"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-corner-court-v1/stage-1.png",
        "buildings/house/compact-corner-court-v1/stage-2.png",
        "buildings/house/compact-corner-court-v1/stage-3.png",
        "buildings/house/compact-corner-court-v1/stage-4.png",
        "buildings/house/compact-corner-court-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ]
      ]
    },
    "compact-u-courtyard-v1": {
      "label": "П-образный дом с внутренним двором",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        96,
        64
      ],
      "footprintCells": [
        12,
        8
      ],
      "anchorPx": [
        48,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "u-courtyard"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-u-courtyard-v1/stage-1.png",
        "buildings/house/compact-u-courtyard-v1/stage-2.png",
        "buildings/house/compact-u-courtyard-v1/stage-3.png",
        "buildings/house/compact-u-courtyard-v1/stage-4.png",
        "buildings/house/compact-u-courtyard-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          92,
          64
        ],
        [
          3,
          0,
          92,
          64
        ],
        [
          0,
          1,
          95,
          64
        ],
        [
          0,
          1,
          95,
          64
        ],
        [
          0,
          1,
          95,
          64
        ]
      ]
    },
    "compact-garden-house-v1": {
      "label": "Дом с садом на крыше",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-garden-house-v1/stage-1.png",
        "buildings/house/compact-garden-house-v1/stage-2.png",
        "buildings/house/compact-garden-house-v1/stage-3.png",
        "buildings/house/compact-garden-house-v1/stage-4.png",
        "buildings/house/compact-garden-house-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ],
        [
          0,
          3,
          48,
          48
        ]
      ]
    },
    "compact-rust-loft-v1": {
      "label": "Кирпичный лофт",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "rust-loft"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 3,
      "stages": [
        "buildings/house/compact-rust-loft-v1/stage-1.png",
        "buildings/house/compact-rust-loft-v1/stage-2.png",
        "buildings/house/compact-rust-loft-v1/stage-3.png",
        "buildings/house/compact-rust-loft-v1/stage-4.png",
        "buildings/house/compact-rust-loft-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          4,
          48,
          48
        ]
      ]
    },
    "compact-sand-balcony-v1": {
      "label": "Дом с песочными балконами",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-sand-balcony-v1/stage-1.png",
        "buildings/house/compact-sand-balcony-v1/stage-2.png",
        "buildings/house/compact-sand-balcony-v1/stage-3.png",
        "buildings/house/compact-sand-balcony-v1/stage-4.png",
        "buildings/house/compact-sand-balcony-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          47,
          48
        ],
        [
          0,
          4,
          47,
          48
        ],
        [
          0,
          4,
          47,
          48
        ]
      ]
    },
    "compact-olive-cafe-v1": {
      "label": "Дом с кафе на террасе",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 3,
      "stages": [
        "buildings/house/compact-olive-cafe-v1/stage-1.png",
        "buildings/house/compact-olive-cafe-v1/stage-2.png",
        "buildings/house/compact-olive-cafe-v1/stage-3.png",
        "buildings/house/compact-olive-cafe-v1/stage-4.png",
        "buildings/house/compact-olive-cafe-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          2,
          48,
          48
        ],
        [
          0,
          2,
          48,
          48
        ]
      ]
    },
    "compact-rose-clinic-annex-v1": {
      "label": "Розовый дом с двумя садами",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-rose-clinic-annex-v1/stage-1.png",
        "buildings/house/compact-rose-clinic-annex-v1/stage-2.png",
        "buildings/house/compact-rose-clinic-annex-v1/stage-3.png",
        "buildings/house/compact-rose-clinic-annex-v1/stage-4.png",
        "buildings/house/compact-rose-clinic-annex-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          4,
          48,
          48
        ]
      ]
    },
    "compact-teal-mansard-v1": {
      "label": "Бирюзовый мансардный дом",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "teal-mansard"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-teal-mansard-v1/stage-1.png",
        "buildings/house/compact-teal-mansard-v1/stage-2.png",
        "buildings/house/compact-teal-mansard-v1/stage-3.png",
        "buildings/house/compact-teal-mansard-v1/stage-4.png",
        "buildings/house/compact-teal-mansard-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          2,
          48,
          48
        ],
        [
          0,
          2,
          48,
          48
        ]
      ]
    },
    "compact-long-slate-wing-v1": {
      "label": "Длинный жилой корпус",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        48,
        96
      ],
      "footprintCells": [
        6,
        12
      ],
      "anchorPx": [
        24,
        96
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "long-slate-wing"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/house/compact-long-slate-wing-v1/stage-1.png",
        "buildings/house/compact-long-slate-wing-v1/stage-2.png",
        "buildings/house/compact-long-slate-wing-v1/stage-3.png",
        "buildings/house/compact-long-slate-wing-v1/stage-4.png",
        "buildings/house/compact-long-slate-wing-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          7,
          48,
          96
        ],
        [
          0,
          7,
          48,
          96
        ],
        [
          0,
          0,
          47,
          96
        ],
        [
          0,
          0,
          47,
          96
        ],
        [
          0,
          0,
          47,
          96
        ]
      ]
    },
    "compact-plum-workshop-v1": {
      "label": "Сливовый дом-мастерская с фонарями",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "stages": [
        "buildings/house/compact-plum-workshop-v1/stage-1.png",
        "buildings/house/compact-plum-workshop-v1/stage-2.png",
        "buildings/house/compact-plum-workshop-v1/stage-3.png",
        "buildings/house/compact-plum-workshop-v1/stage-4.png",
        "buildings/house/compact-plum-workshop-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          4,
          48,
          48
        ],
        [
          0,
          4,
          48,
          48
        ]
      ]
    },
    "compact-city-mall-v1": {
      "label": "Торговый центр «Атриум»",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "shopping-mall"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-city-mall-v1/stage-1.png",
        "buildings/commercial/compact-city-mall-v1/stage-2.png",
        "buildings/commercial/compact-city-mall-v1/stage-3.png",
        "buildings/commercial/compact-city-mall-v1/stage-4.png",
        "buildings/commercial/compact-city-mall-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          2,
          96,
          48
        ],
        [
          0,
          2,
          96,
          48
        ],
        [
          0,
          2,
          96,
          48
        ]
      ]
    },
    "compact-entertainment-centre-v1": {
      "label": "Кинотеатр и боулинг",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "entertainment-centre"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-entertainment-centre-v1/stage-1.png",
        "buildings/commercial/compact-entertainment-centre-v1/stage-2.png",
        "buildings/commercial/compact-entertainment-centre-v1/stage-3.png",
        "buildings/commercial/compact-entertainment-centre-v1/stage-4.png",
        "buildings/commercial/compact-entertainment-centre-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ]
      ]
    },
    "compact-waterpark-v1": {
      "label": "Аквапарк",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        64
      ],
      "footprintCells": [
        12,
        8
      ],
      "anchorPx": [
        48,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "waterpark"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-waterpark-v1/stage-1.png",
        "buildings/commercial/compact-waterpark-v1/stage-2.png",
        "buildings/commercial/compact-waterpark-v1/stage-3.png",
        "buildings/commercial/compact-waterpark-v1/stage-4.png",
        "buildings/commercial/compact-waterpark-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          92,
          64
        ],
        [
          3,
          0,
          92,
          64
        ],
        [
          0,
          3,
          96,
          64
        ],
        [
          0,
          3,
          96,
          64
        ],
        [
          0,
          3,
          96,
          64
        ]
      ]
    },
    "compact-sports-arena-v1": {
      "label": "Спортивная арена",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "sports-arena"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-sports-arena-v1/stage-1.png",
        "buildings/commercial/compact-sports-arena-v1/stage-2.png",
        "buildings/commercial/compact-sports-arena-v1/stage-3.png",
        "buildings/commercial/compact-sports-arena-v1/stage-4.png",
        "buildings/commercial/compact-sports-arena-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ]
      ]
    },
    "compact-covered-market-v1": {
      "label": "Крытый рынок",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "covered-market"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-covered-market-v1/stage-1.png",
        "buildings/commercial/compact-covered-market-v1/stage-2.png",
        "buildings/commercial/compact-covered-market-v1/stage-3.png",
        "buildings/commercial/compact-covered-market-v1/stage-4.png",
        "buildings/commercial/compact-covered-market-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ]
      ]
    },
    "compact-city-museum-v1": {
      "label": "Музей с внутренним двором",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "city-museum"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-city-museum-v1/stage-1.png",
        "buildings/commercial/compact-city-museum-v1/stage-2.png",
        "buildings/commercial/compact-city-museum-v1/stage-3.png",
        "buildings/commercial/compact-city-museum-v1/stage-4.png",
        "buildings/commercial/compact-city-museum-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ]
      ]
    },
    "compact-botanical-greenhouse-v1": {
      "label": "Ботаническая оранжерея",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "botanical-greenhouse"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-botanical-greenhouse-v1/stage-1.png",
        "buildings/commercial/compact-botanical-greenhouse-v1/stage-2.png",
        "buildings/commercial/compact-botanical-greenhouse-v1/stage-3.png",
        "buildings/commercial/compact-botanical-greenhouse-v1/stage-4.png",
        "buildings/commercial/compact-botanical-greenhouse-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ]
      ]
    },
    "compact-terrace-hotel-v1": {
      "label": "Отель с террасами",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        64
      ],
      "footprintCells": [
        12,
        8
      ],
      "anchorPx": [
        48,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "terrace-hotel"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-terrace-hotel-v1/stage-1.png",
        "buildings/commercial/compact-terrace-hotel-v1/stage-2.png",
        "buildings/commercial/compact-terrace-hotel-v1/stage-3.png",
        "buildings/commercial/compact-terrace-hotel-v1/stage-4.png",
        "buildings/commercial/compact-terrace-hotel-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          92,
          64
        ],
        [
          3,
          0,
          92,
          64
        ],
        [
          0,
          1,
          96,
          64
        ],
        [
          0,
          1,
          96,
          64
        ],
        [
          0,
          1,
          96,
          64
        ]
      ]
    },
    "compact-business-centre-v1": {
      "label": "Деловой центр",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        48,
        96
      ],
      "footprintCells": [
        6,
        12
      ],
      "anchorPx": [
        24,
        96
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "business-centre"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-business-centre-v1/stage-1.png",
        "buildings/commercial/compact-business-centre-v1/stage-2.png",
        "buildings/commercial/compact-business-centre-v1/stage-3.png",
        "buildings/commercial/compact-business-centre-v1/stage-4.png",
        "buildings/commercial/compact-business-centre-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          7,
          48,
          96
        ],
        [
          0,
          7,
          48,
          96
        ],
        [
          0,
          0,
          47,
          96
        ],
        [
          0,
          0,
          47,
          96
        ],
        [
          0,
          0,
          47,
          96
        ]
      ]
    },
    "compact-planetarium-v1": {
      "label": "Планетарий",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "planetarium"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-planetarium-v1/stage-1.png",
        "buildings/commercial/compact-planetarium-v1/stage-2.png",
        "buildings/commercial/compact-planetarium-v1/stage-3.png",
        "buildings/commercial/compact-planetarium-v1/stage-4.png",
        "buildings/commercial/compact-planetarium-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          63,
          64
        ],
        [
          0,
          0,
          63,
          64
        ],
        [
          0,
          0,
          63,
          64
        ]
      ]
    },
    "compact-theatre-v1": {
      "label": "Городской театр",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "theatre"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-theatre-v1/stage-1.png",
        "buildings/commercial/compact-theatre-v1/stage-2.png",
        "buildings/commercial/compact-theatre-v1/stage-3.png",
        "buildings/commercial/compact-theatre-v1/stage-4.png",
        "buildings/commercial/compact-theatre-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          3,
          62,
          64
        ],
        [
          1,
          0,
          62,
          64
        ],
        [
          1,
          0,
          62,
          64
        ]
      ]
    },
    "compact-concert-hall-v1": {
      "label": "Концертный зал",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "concert-hall"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-concert-hall-v1/stage-1.png",
        "buildings/commercial/compact-concert-hall-v1/stage-2.png",
        "buildings/commercial/compact-concert-hall-v1/stage-3.png",
        "buildings/commercial/compact-concert-hall-v1/stage-4.png",
        "buildings/commercial/compact-concert-hall-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ]
      ]
    },
    "compact-aquarium-v1": {
      "label": "Океанариум",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "aquarium"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-aquarium-v1/stage-1.png",
        "buildings/commercial/compact-aquarium-v1/stage-2.png",
        "buildings/commercial/compact-aquarium-v1/stage-3.png",
        "buildings/commercial/compact-aquarium-v1/stage-4.png",
        "buildings/commercial/compact-aquarium-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ]
      ]
    },
    "compact-exhibition-centre-v1": {
      "label": "Выставочный центр",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "exhibition-centre"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-exhibition-centre-v1/stage-1.png",
        "buildings/commercial/compact-exhibition-centre-v1/stage-2.png",
        "buildings/commercial/compact-exhibition-centre-v1/stage-3.png",
        "buildings/commercial/compact-exhibition-centre-v1/stage-4.png",
        "buildings/commercial/compact-exhibition-centre-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          0,
          96,
          48
        ],
        [
          0,
          0,
          96,
          48
        ]
      ]
    },
    "compact-central-library-v1": {
      "label": "Центральная библиотека",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "central-library"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-central-library-v1/stage-1.png",
        "buildings/commercial/compact-central-library-v1/stage-2.png",
        "buildings/commercial/compact-central-library-v1/stage-3.png",
        "buildings/commercial/compact-central-library-v1/stage-4.png",
        "buildings/commercial/compact-central-library-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ]
      ]
    },
    "compact-science-centre-v1": {
      "label": "Научный центр",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "science-centre"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-science-centre-v1/stage-1.png",
        "buildings/commercial/compact-science-centre-v1/stage-2.png",
        "buildings/commercial/compact-science-centre-v1/stage-3.png",
        "buildings/commercial/compact-science-centre-v1/stage-4.png",
        "buildings/commercial/compact-science-centre-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ]
      ]
    },
    "compact-art-gallery-v1": {
      "label": "Художественная галерея",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        96,
        48
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        48
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "art-gallery"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 6
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-art-gallery-v1/stage-1.png",
        "buildings/commercial/compact-art-gallery-v1/stage-2.png",
        "buildings/commercial/compact-art-gallery-v1/stage-3.png",
        "buildings/commercial/compact-art-gallery-v1/stage-4.png",
        "buildings/commercial/compact-art-gallery-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          5,
          0,
          90,
          48
        ],
        [
          5,
          0,
          90,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ],
        [
          0,
          1,
          96,
          48
        ]
      ]
    },
    "compact-four-floor-house-v1": {
      "label": "Четырёхэтажный дом с мансардой",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 4,
      "stages": [
        "buildings/house/compact-four-floor-house-v1/stage-1.png",
        "buildings/house/compact-four-floor-house-v1/stage-2.png",
        "buildings/house/compact-four-floor-house-v1/stage-3.png",
        "buildings/house/compact-four-floor-house-v1/stage-4.png",
        "buildings/house/compact-four-floor-house-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          5,
          48,
          48
        ],
        [
          0,
          5,
          48,
          48
        ],
        [
          0,
          5,
          48,
          48
        ]
      ]
    },
    "compact-observatory-v1": {
      "label": "Обсерватория",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "observatory"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-observatory-v1/stage-1.png",
        "buildings/commercial/compact-observatory-v1/stage-2.png",
        "buildings/commercial/compact-observatory-v1/stage-3.png",
        "buildings/commercial/compact-observatory-v1/stage-4.png",
        "buildings/commercial/compact-observatory-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          7,
          64,
          64
        ],
        [
          0,
          7,
          64,
          64
        ],
        [
          0,
          7,
          64,
          64
        ]
      ]
    },
    "compact-thermal-baths-v1": {
      "label": "Термальные купальни",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "thermal-baths"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-thermal-baths-v1/stage-1.png",
        "buildings/commercial/compact-thermal-baths-v1/stage-2.png",
        "buildings/commercial/compact-thermal-baths-v1/stage-3.png",
        "buildings/commercial/compact-thermal-baths-v1/stage-4.png",
        "buildings/commercial/compact-thermal-baths-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ],
        [
          0,
          0,
          64,
          64
        ]
      ]
    },
    "compact-ice-palace-v1": {
      "label": "Ледовый дворец",
      "category": "COMMERCIAL",
      "rarity": "UNIQUE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-landmark",
        "ice-palace"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 2,
      "stages": [
        "buildings/commercial/compact-ice-palace-v1/stage-1.png",
        "buildings/commercial/compact-ice-palace-v1/stage-2.png",
        "buildings/commercial/compact-ice-palace-v1/stage-3.png",
        "buildings/commercial/compact-ice-palace-v1/stage-4.png",
        "buildings/commercial/compact-ice-palace-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          63,
          64
        ],
        [
          1,
          0,
          63,
          64
        ],
        [
          0,
          1,
          64,
          64
        ],
        [
          0,
          1,
          64,
          64
        ],
        [
          0,
          1,
          64,
          64
        ]
      ]
    },
    "compact-port-v1": {
      "label": "Морской порт",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "port"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": 1,
      "maxPerDistrict": null,
      "serviceRole": "PORT",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-port-v1/stage-1.png",
        "buildings/civic/compact-port-v1/stage-2.png",
        "buildings/civic/compact-port-v1/stage-3.png",
        "buildings/civic/compact-port-v1/stage-4.png",
        "buildings/civic/compact-port-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-olive-five-floor-v1": {
      "label": "Пятиэтажный оливковый дом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        56
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        56
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 1
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 5,
      "stages": [
        "buildings/house/compact-olive-five-floor-v1/stage-1.png",
        "buildings/house/compact-olive-five-floor-v1/stage-2.png",
        "buildings/house/compact-olive-five-floor-v1/stage-3.png",
        "buildings/house/compact-olive-five-floor-v1/stage-4.png",
        "buildings/house/compact-olive-five-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          6,
          48,
          56
        ],
        [
          0,
          6,
          48,
          56
        ],
        [
          0,
          1,
          48,
          56
        ],
        [
          0,
          1,
          48,
          56
        ],
        [
          0,
          1,
          48,
          56
        ]
      ]
    },
    "compact-panel-four-floor-v1": {
      "label": "Четырёхэтажный панельный дом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "N",
          "offset": 4
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 4,
      "stages": [
        "buildings/house/compact-panel-four-floor-v1/stage-1.png",
        "buildings/house/compact-panel-four-floor-v1/stage-2.png",
        "buildings/house/compact-panel-four-floor-v1/stage-3.png",
        "buildings/house/compact-panel-four-floor-v1/stage-4.png",
        "buildings/house/compact-panel-four-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          1,
          0,
          47,
          48
        ],
        [
          1,
          0,
          47,
          48
        ],
        [
          0,
          0,
          48,
          48
        ],
        [
          0,
          0,
          48,
          48
        ],
        [
          0,
          0,
          48,
          48
        ]
      ]
    },
    "compact-gallery-four-floor-v1": {
      "label": "Четырёхэтажный галерейный дом",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        48
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        48
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "E",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 4,
      "stages": [
        "buildings/house/compact-gallery-four-floor-v1/stage-1.png",
        "buildings/house/compact-gallery-four-floor-v1/stage-2.png",
        "buildings/house/compact-gallery-four-floor-v1/stage-3.png",
        "buildings/house/compact-gallery-four-floor-v1/stage-4.png",
        "buildings/house/compact-gallery-four-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          0,
          47,
          48
        ],
        [
          0,
          0,
          47,
          48
        ],
        [
          0,
          2,
          48,
          48
        ],
        [
          0,
          2,
          48,
          48
        ],
        [
          0,
          2,
          48,
          48
        ]
      ]
    },
    "compact-court-four-floor-v1": {
      "label": "Четырёхэтажный дом с двором",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        64,
        64
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        64
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "corner-court"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "W",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 4,
      "stages": [
        "buildings/house/compact-court-four-floor-v1/stage-1.png",
        "buildings/house/compact-court-four-floor-v1/stage-2.png",
        "buildings/house/compact-court-four-floor-v1/stage-3.png",
        "buildings/house/compact-court-four-floor-v1/stage-4.png",
        "buildings/house/compact-court-four-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          0,
          63,
          64
        ],
        [
          0,
          0,
          63,
          64
        ],
        [
          0,
          2,
          64,
          64
        ],
        [
          0,
          2,
          64,
          64
        ],
        [
          0,
          2,
          64,
          64
        ]
      ]
    },
    "compact-section-five-floor-v1": {
      "label": "Секционная кирпичная пятиэтажка",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        96,
        56
      ],
      "footprintCells": [
        12,
        6
      ],
      "anchorPx": [
        48,
        56
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "long-gallery"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 9
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 5,
      "stages": [
        "buildings/house/compact-section-five-floor-v1/stage-1.png",
        "buildings/house/compact-section-five-floor-v1/stage-2.png",
        "buildings/house/compact-section-five-floor-v1/stage-3.png",
        "buildings/house/compact-section-five-floor-v1/stage-4.png",
        "buildings/house/compact-section-five-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          2,
          96,
          56
        ],
        [
          0,
          2,
          96,
          56
        ],
        [
          0,
          4,
          96,
          56
        ],
        [
          0,
          4,
          96,
          56
        ],
        [
          0,
          4,
          96,
          56
        ]
      ]
    },
    "compact-corner-five-floor-v1": {
      "label": "Угловая пятиэтажка с лоджиями",
      "category": "HOUSE",
      "rarity": "RARE",
      "spriteSize": [
        64,
        72
      ],
      "footprintCells": [
        8,
        8
      ],
      "anchorPx": [
        32,
        72
      ],
      "platform": "STONE",
      "estimates": [
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building",
        "corner-court"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 1
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 5,
      "stages": [
        "buildings/house/compact-corner-five-floor-v1/stage-1.png",
        "buildings/house/compact-corner-five-floor-v1/stage-2.png",
        "buildings/house/compact-corner-five-floor-v1/stage-3.png",
        "buildings/house/compact-corner-five-floor-v1/stage-4.png",
        "buildings/house/compact-corner-five-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          6,
          64,
          72
        ],
        [
          0,
          6,
          64,
          72
        ],
        [
          0,
          0,
          63,
          72
        ],
        [
          0,
          0,
          63,
          72
        ],
        [
          0,
          0,
          63,
          72
        ]
      ]
    },
    "compact-modern-five-floor-v1": {
      "label": "Современная пятиэтажка со стеклянной лестницей",
      "category": "HOUSE",
      "rarity": "COMMON",
      "spriteSize": [
        48,
        56
      ],
      "footprintCells": [
        6,
        6
      ],
      "anchorPx": [
        24,
        56
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "residential",
        "low-rise-residential",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": null,
      "serviceRole": null,
      "floorCount": 5,
      "stages": [
        "buildings/house/compact-modern-five-floor-v1/stage-1.png",
        "buildings/house/compact-modern-five-floor-v1/stage-2.png",
        "buildings/house/compact-modern-five-floor-v1/stage-3.png",
        "buildings/house/compact-modern-five-floor-v1/stage-4.png",
        "buildings/house/compact-modern-five-floor-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          0,
          6,
          48,
          56
        ],
        [
          0,
          6,
          48,
          56
        ],
        [
          0,
          1,
          48,
          56
        ],
        [
          0,
          1,
          48,
          56
        ],
        [
          0,
          1,
          48,
          56
        ]
      ]
    },
    "compact-brick-school-v1": {
      "label": "Кирпичная школа с крылом",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "education"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 1
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "EDUCATION",
      "floorCount": 2,
      "educationKind": "SCHOOL",
      "stages": [
        "buildings/civic/compact-brick-school-v1/stage-1.png",
        "buildings/civic/compact-brick-school-v1/stage-2.png",
        "buildings/civic/compact-brick-school-v1/stage-3.png",
        "buildings/civic/compact-brick-school-v1/stage-4.png",
        "buildings/civic/compact-brick-school-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          3,
          48,
          32
        ],
        [
          0,
          3,
          48,
          32
        ],
        [
          0,
          3,
          48,
          32
        ]
      ]
    },
    "compact-modern-school-v1": {
      "label": "Современная школа с террасой",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "education"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "N",
          "offset": 5
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "EDUCATION",
      "floorCount": 2,
      "educationKind": "SCHOOL",
      "stages": [
        "buildings/civic/compact-modern-school-v1/stage-1.png",
        "buildings/civic/compact-modern-school-v1/stage-2.png",
        "buildings/civic/compact-modern-school-v1/stage-3.png",
        "buildings/civic/compact-modern-school-v1/stage-4.png",
        "buildings/civic/compact-modern-school-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          7,
          48,
          32
        ]
      ]
    },
    "compact-color-kindergarten-v1": {
      "label": "Цветной детский сад",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "education"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 5
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "EDUCATION",
      "floorCount": 1,
      "educationKind": "KINDERGARTEN",
      "stages": [
        "buildings/civic/compact-color-kindergarten-v1/stage-1.png",
        "buildings/civic/compact-color-kindergarten-v1/stage-2.png",
        "buildings/civic/compact-color-kindergarten-v1/stage-3.png",
        "buildings/civic/compact-color-kindergarten-v1/stage-4.png",
        "buildings/civic/compact-color-kindergarten-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          6,
          48,
          32
        ],
        [
          0,
          6,
          48,
          32
        ],
        [
          0,
          6,
          48,
          32
        ]
      ]
    },
    "compact-rose-kindergarten-v1": {
      "label": "Двухэтажный детский сад с лоджией",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "education"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 2
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "EDUCATION",
      "floorCount": 2,
      "educationKind": "KINDERGARTEN",
      "stages": [
        "buildings/civic/compact-rose-kindergarten-v1/stage-1.png",
        "buildings/civic/compact-rose-kindergarten-v1/stage-2.png",
        "buildings/civic/compact-rose-kindergarten-v1/stage-3.png",
        "buildings/civic/compact-rose-kindergarten-v1/stage-4.png",
        "buildings/civic/compact-rose-kindergarten-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ],
        [
          1,
          0,
          47,
          32
        ]
      ]
    },
    "compact-court-kindergarten-v1": {
      "label": "Детский сад с игровым двором",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "education"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 1
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "EDUCATION",
      "floorCount": 1,
      "educationKind": "KINDERGARTEN",
      "stages": [
        "buildings/civic/compact-court-kindergarten-v1/stage-1.png",
        "buildings/civic/compact-court-kindergarten-v1/stage-2.png",
        "buildings/civic/compact-court-kindergarten-v1/stage-3.png",
        "buildings/civic/compact-court-kindergarten-v1/stage-4.png",
        "buildings/civic/compact-court-kindergarten-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          7,
          48,
          32
        ]
      ]
    },
    "compact-brick-police-v1": {
      "label": "Кирпичное отделение полиции",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "police"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "POLICE",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-brick-police-v1/stage-1.png",
        "buildings/civic/compact-brick-police-v1/stage-2.png",
        "buildings/civic/compact-brick-police-v1/stage-3.png",
        "buildings/civic/compact-brick-police-v1/stage-4.png",
        "buildings/civic/compact-brick-police-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          0,
          47,
          32
        ],
        [
          0,
          0,
          47,
          32
        ],
        [
          0,
          0,
          47,
          32
        ]
      ]
    },
    "compact-modern-police-v1": {
      "label": "Современное отделение полиции",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "police"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "N",
          "offset": 1
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "POLICE",
      "floorCount": 1,
      "stages": [
        "buildings/civic/compact-modern-police-v1/stage-1.png",
        "buildings/civic/compact-modern-police-v1/stage-2.png",
        "buildings/civic/compact-modern-police-v1/stage-3.png",
        "buildings/civic/compact-modern-police-v1/stage-4.png",
        "buildings/civic/compact-modern-police-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          1,
          3,
          46,
          32
        ],
        [
          1,
          3,
          46,
          32
        ],
        [
          1,
          0,
          46,
          32
        ]
      ]
    },
    "compact-tower-fire-station-v1": {
      "label": "Пожарная часть с башней",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "civic",
        "fire-station",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 0
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "FIRE",
      "floorCount": 2,
      "stages": [
        "buildings/civic/compact-tower-fire-station-v1/stage-1.png",
        "buildings/civic/compact-tower-fire-station-v1/stage-2.png",
        "buildings/civic/compact-tower-fire-station-v1/stage-3.png",
        "buildings/civic/compact-tower-fire-station-v1/stage-4.png",
        "buildings/civic/compact-tower-fire-station-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          7,
          48,
          32
        ]
      ]
    },
    "compact-hall-fire-station-v1": {
      "label": "Гаражный корпус пожарной части",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "civic",
        "fire-station",
        "compact-building"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 5
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "FIRE",
      "floorCount": 1,
      "stages": [
        "buildings/civic/compact-hall-fire-station-v1/stage-1.png",
        "buildings/civic/compact-hall-fire-station-v1/stage-2.png",
        "buildings/civic/compact-hall-fire-station-v1/stage-3.png",
        "buildings/civic/compact-hall-fire-station-v1/stage-4.png",
        "buildings/civic/compact-hall-fire-station-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          3,
          48,
          32
        ],
        [
          0,
          3,
          48,
          32
        ],
        [
          0,
          3,
          48,
          32
        ]
      ]
    },
    "compact-bakery-shop-v1": {
      "label": "Магазин-пекарня",
      "category": "COMMERCIAL",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "shop"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 1
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "SHOP",
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-bakery-shop-v1/stage-1.png",
        "buildings/commercial/compact-bakery-shop-v1/stage-2.png",
        "buildings/commercial/compact-bakery-shop-v1/stage-3.png",
        "buildings/commercial/compact-bakery-shop-v1/stage-4.png",
        "buildings/commercial/compact-bakery-shop-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          7,
          48,
          32
        ],
        [
          0,
          8,
          48,
          32
        ],
        [
          0,
          5,
          48,
          32
        ]
      ]
    },
    "compact-corner-shop-v1": {
      "label": "Угловой магазин с двором",
      "category": "COMMERCIAL",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "shop"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "E",
          "offset": 2
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "SHOP",
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-corner-shop-v1/stage-1.png",
        "buildings/commercial/compact-corner-shop-v1/stage-2.png",
        "buildings/commercial/compact-corner-shop-v1/stage-3.png",
        "buildings/commercial/compact-corner-shop-v1/stage-4.png",
        "buildings/commercial/compact-corner-shop-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          2,
          0,
          45,
          32
        ],
        [
          2,
          0,
          45,
          32
        ],
        [
          0,
          2,
          46,
          32
        ],
        [
          0,
          2,
          48,
          32
        ],
        [
          0,
          2,
          48,
          32
        ]
      ]
    },
    "compact-supermarket-v1": {
      "label": "Небольшой супермаркет",
      "category": "COMMERCIAL",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "shop"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 4
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "SHOP",
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-supermarket-v1/stage-1.png",
        "buildings/commercial/compact-supermarket-v1/stage-2.png",
        "buildings/commercial/compact-supermarket-v1/stage-3.png",
        "buildings/commercial/compact-supermarket-v1/stage-4.png",
        "buildings/commercial/compact-supermarket-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          4,
          48,
          32
        ],
        [
          0,
          4,
          48,
          32
        ],
        [
          0,
          4,
          48,
          32
        ]
      ]
    },
    "compact-flower-shop-v1": {
      "label": "Цветочный магазин с оранжереей",
      "category": "COMMERCIAL",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        32
      ],
      "footprintCells": [
        6,
        4
      ],
      "anchorPx": [
        24,
        32
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "shop"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 0
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "SHOP",
      "floorCount": 1,
      "stages": [
        "buildings/commercial/compact-flower-shop-v1/stage-1.png",
        "buildings/commercial/compact-flower-shop-v1/stage-2.png",
        "buildings/commercial/compact-flower-shop-v1/stage-3.png",
        "buildings/commercial/compact-flower-shop-v1/stage-4.png",
        "buildings/commercial/compact-flower-shop-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          3,
          0,
          45,
          32
        ],
        [
          3,
          0,
          45,
          32
        ],
        [
          0,
          11,
          48,
          32
        ],
        [
          0,
          11,
          48,
          32
        ],
        [
          0,
          11,
          48,
          32
        ]
      ]
    },
    "compact-airport-row-v1": {
      "label": "Малый аэровокзал",
      "category": "CIVIC",
      "rarity": "UNCOMMON",
      "spriteSize": [
        48,
        24
      ],
      "footprintCells": [
        6,
        3
      ],
      "anchorPx": [
        24,
        24
      ],
      "platform": "STONE",
      "estimates": [
        1,
        2,
        3,
        6
      ],
      "tags": [
        "compact-building",
        "city-service",
        "airport"
      ],
      "ruleIds": [
        "STANDARD"
      ],
      "entrances": [
        {
          "side": "S",
          "offset": 3
        }
      ],
      "maxPerCity": null,
      "maxPerDistrict": 1,
      "serviceRole": "AIRPORT",
      "floorCount": 1,
      "stages": [
        "buildings/civic/compact-airport-row-v1/stage-1.png",
        "buildings/civic/compact-airport-row-v1/stage-2.png",
        "buildings/civic/compact-airport-row-v1/stage-3.png",
        "buildings/civic/compact-airport-row-v1/stage-4.png",
        "buildings/civic/compact-airport-row-v1/stage-5.png"
      ],
      "stageOpaqueBounds": [
        [
          4,
          0,
          43,
          24
        ],
        [
          4,
          0,
          43,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ],
        [
          0,
          2,
          48,
          24
        ]
      ]
    }
  },
  "props": {
    "bus-stop-horizontal": {
      "label": "Городская остановка",
      "path": "props/bus-stop-horizontal.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/bus-stop-canonical-v2.png",
      "visualProfile": "TASKTOPIA_V5_TRANSIT_STOP_FRONTAL_TOP"
    },
    "bus-stop-vertical": {
      "label": "Городская остановка",
      "path": "props/bus-stop-vertical.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/bus-stop-canonical-v2.png",
      "visualProfile": "TASKTOPIA_V5_TRANSIT_STOP_FRONTAL_TOP"
    },
    "bench-horizontal": {
      "label": "Городская скамейка — горизонтально",
      "path": "props/bench-horizontal.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "occupiedSize": [
        14,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "bench-vertical": {
      "label": "Городская скамейка — вертикально",
      "path": "props/bench-vertical.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        2
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "trash-bin": {
      "label": "Городская урна",
      "path": "props/trash-bin.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "recycling-bin": {
      "label": "Контейнер для переработки",
      "path": "props/recycling-bin.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "streetlamp": {
      "label": "Классический фонарь — выключен",
      "path": "props/streetlamp.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-lit": {
      "label": "Классический фонарь — включён",
      "path": "props/streetlamp-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-modern": {
      "label": "Современный фонарь — выключен",
      "path": "props/streetlamp-modern.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-modern-lit": {
      "label": "Современный фонарь — включён",
      "path": "props/streetlamp-modern-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-double": {
      "label": "Двойной фонарь — выключен",
      "path": "props/streetlamp-double.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-double-lit": {
      "label": "Двойной фонарь — включён",
      "path": "props/streetlamp-double-lit.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "traffic-light-red": {
      "label": "Компактный светофор — красный",
      "path": "props/traffic-light-red.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        5,
        11
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_COMPACT_TRAFFIC_LIGHT"
    },
    "traffic-light-green": {
      "label": "Компактный светофор — зелёный",
      "path": "props/traffic-light-green.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        5,
        11
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-furniture-lighting-v1.png",
      "visualProfile": "TASKTOPIA_V5_COMPACT_TRAFFIC_LIGHT"
    },
    "flower-white": {
      "label": "Белые цветы",
      "path": "props/flower-white.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/nature-small-v2.png",
      "visualProfile": "TASKTOPIA_V6_SEEDED_NATURE"
    },
    "flower-yellow": {
      "label": "Жёлтые цветы",
      "path": "props/flower-yellow.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/nature-small-v2.png",
      "visualProfile": "TASKTOPIA_V6_SEEDED_NATURE"
    },
    "flower-pink": {
      "label": "Розовые цветы",
      "path": "props/flower-pink.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/nature-small-v2.png",
      "visualProfile": "TASKTOPIA_V6_SEEDED_NATURE"
    },
    "shrub-flowering": {
      "label": "Цветущий куст",
      "path": "props/shrub-flowering.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/nature-small-v2.png",
      "visualProfile": "TASKTOPIA_V6_SEEDED_NATURE"
    },
    "tree-flowering": {
      "label": "Цветущее деревце",
      "path": "props/tree-flowering.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-flowering.png"
    },
    "utility-pole": {
      "label": "Городской столб",
      "path": "props/utility-pole.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "planter-round": {
      "label": "Круглая клумба",
      "path": "props/planter-round.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "fire-hydrant": {
      "label": "Пожарный гидрант",
      "path": "props/fire-hydrant.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "mailbox": {
      "label": "Почтовый ящик",
      "path": "props/mailbox.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "bollard": {
      "label": "Дорожный столбик",
      "path": "props/bollard.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "bicycle-rack": {
      "label": "Велопарковка",
      "path": "props/bicycle-rack.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "occupiedSize": [
        14,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "fountain-small": {
      "label": "Малый городской фонтан",
      "path": "props/fountain-small.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "picnic-table": {
      "label": "Стол для отдыха",
      "path": "props/picnic-table.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "streetlamp-vintage": {
      "label": "Винтажный фонарь — выключен",
      "path": "props/streetlamp-vintage.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-solar": {
      "label": "Солнечный фонарь — выключен",
      "path": "props/streetlamp-solar.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-industrial": {
      "label": "Промышленный фонарь — выключен",
      "path": "props/streetlamp-industrial.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-festive": {
      "label": "Праздничный фонарь — выключен",
      "path": "props/streetlamp-festive.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "city-sign-horizontal": {
      "label": "Городской указатель — горизонтальный маршрут",
      "path": "props/city-sign-horizontal.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "city-sign-vertical": {
      "label": "Городской указатель — вертикальный маршрут",
      "path": "props/city-sign-vertical.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "active-district-flag": {
      "label": "Флаг активного района",
      "path": "props/active-district-flag.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/civic-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "bandstand": {
      "label": "Парковая эстрада",
      "path": "props/bandstand.png",
      "size": [
        40,
        32
      ],
      "footprintCells": [
        5,
        3
      ],
      "anchorPx": [
        20,
        32
      ],
      "occupiedSize": [
        38,
        31
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "statue-hero": {
      "label": "Памятник герою",
      "path": "props/statue-hero.png",
      "size": [
        16,
        24
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        24
      ],
      "occupiedSize": [
        14,
        23
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "statue-abstract": {
      "label": "Абстрактная скульптура",
      "path": "props/statue-abstract.png",
      "size": [
        16,
        24
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        24
      ],
      "occupiedSize": [
        14,
        23
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "topiary-spiral": {
      "label": "Спиральный топиарий",
      "path": "props/topiary-spiral.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "topiary-animal": {
      "label": "Фигурный топиарий",
      "path": "props/topiary-animal.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "pond-small": {
      "label": "Малый парковый пруд",
      "path": "props/pond-small.png",
      "size": [
        24,
        24
      ],
      "footprintCells": [
        3,
        3
      ],
      "anchorPx": [
        12,
        24
      ],
      "occupiedSize": [
        22,
        23
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "flower-bed-horizontal": {
      "label": "Цветник — горизонтально",
      "path": "props/flower-bed-horizontal.png",
      "size": [
        24,
        8
      ],
      "footprintCells": [
        3,
        1
      ],
      "anchorPx": [
        12,
        8
      ],
      "occupiedSize": [
        22,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "flower-bed-vertical": {
      "label": "Цветник — вертикально",
      "path": "props/flower-bed-vertical.png",
      "size": [
        8,
        24
      ],
      "footprintCells": [
        1,
        3
      ],
      "anchorPx": [
        4,
        24
      ],
      "occupiedSize": [
        6,
        23
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-bench-double": {
      "label": "Двойная парковая скамейка",
      "path": "props/park-bench-double.png",
      "size": [
        24,
        16
      ],
      "footprintCells": [
        3,
        1
      ],
      "anchorPx": [
        12,
        16
      ],
      "occupiedSize": [
        22,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-bridge": {
      "label": "Парковый мостик",
      "path": "props/park-bridge.png",
      "size": [
        32,
        16
      ],
      "footprintCells": [
        4,
        2
      ],
      "anchorPx": [
        16,
        16
      ],
      "occupiedSize": [
        30,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-lamp": {
      "label": "Парковый фонарь — выключен",
      "path": "props/park-lamp.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-vintage-lit": {
      "label": "Винтажный фонарь — включён",
      "path": "props/streetlamp-vintage-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-solar-lit": {
      "label": "Солнечный фонарь — включён",
      "path": "props/streetlamp-solar-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-industrial-lit": {
      "label": "Промышленный фонарь — включён",
      "path": "props/streetlamp-industrial-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "streetlamp-festive-lit": {
      "label": "Праздничный фонарь — включён",
      "path": "props/streetlamp-festive-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "park-lamp-lit": {
      "label": "Парковый фонарь — включён",
      "path": "props/park-lamp-lit.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/street-lamps-night-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_LIGHT_FRONTAL_TOP"
    },
    "park-path-circle": {
      "label": "Круглая парковая площадка",
      "path": "props/park-path-circle.png",
      "size": [
        24,
        24
      ],
      "footprintCells": [
        3,
        3
      ],
      "anchorPx": [
        12,
        24
      ],
      "occupiedSize": [
        22,
        23
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "guardrail-horizontal": {
      "label": "Ограждение — горизонтально",
      "path": "props/guardrail-horizontal.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "occupiedSize": [
        14,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "guardrail-vertical": {
      "label": "Ограждение — вертикально",
      "path": "props/guardrail-vertical.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        2
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-details-v1.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "boat-horizontal-a": {
      "label": "Гребная лодка",
      "path": "props/boat-horizontal-a.png",
      "size": [
        24,
        8
      ],
      "footprintCells": [
        3,
        1
      ],
      "anchorPx": [
        12,
        8
      ],
      "occupiedSize": [
        10,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "EAST"
    },
    "boat-horizontal-b": {
      "label": "Рыбацкий катер",
      "path": "props/boat-horizontal-b.png",
      "size": [
        24,
        8
      ],
      "footprintCells": [
        3,
        1
      ],
      "anchorPx": [
        12,
        8
      ],
      "occupiedSize": [
        12,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "EAST"
    },
    "boat-vertical-a": {
      "label": "Гребная лодка",
      "path": "props/boat-vertical-a.png",
      "size": [
        8,
        24
      ],
      "footprintCells": [
        1,
        3
      ],
      "anchorPx": [
        4,
        24
      ],
      "occupiedSize": [
        6,
        10
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "SOUTH"
    },
    "boat-vertical-b": {
      "label": "Рыбацкий катер",
      "path": "props/boat-vertical-b.png",
      "size": [
        8,
        24
      ],
      "footprintCells": [
        1,
        3
      ],
      "anchorPx": [
        4,
        24
      ],
      "occupiedSize": [
        6,
        12
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "SOUTH"
    },
    "hill-small": {
      "label": "Небольшой холм",
      "path": "props/hill-small.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_LANDFORM_FRONTAL_TOP"
    },
    "hill-rocky": {
      "label": "Каменистый холм",
      "path": "props/hill-rocky.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_LANDFORM_FRONTAL_TOP"
    },
    "mountain-peak": {
      "label": "Горная вершина",
      "path": "props/mountain-peak.png",
      "size": [
        16,
        24
      ],
      "footprintCells": [
        2,
        3
      ],
      "anchorPx": [
        8,
        24
      ],
      "occupiedSize": [
        14,
        23
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_LANDFORM_FRONTAL_TOP"
    },
    "mountain-ridge": {
      "label": "Горный хребет",
      "path": "props/mountain-ridge.png",
      "size": [
        24,
        16
      ],
      "footprintCells": [
        3,
        2
      ],
      "anchorPx": [
        12,
        16
      ],
      "occupiedSize": [
        22,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_LANDFORM_FRONTAL_TOP"
    },
    "fence-horizontal": {
      "label": "Городская ограда — горизонтально",
      "path": "props/fence-horizontal.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "occupiedSize": [
        14,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_FENCE_FRONTAL_TOP"
    },
    "fence-vertical": {
      "label": "Городская ограда — вертикально",
      "path": "props/fence-vertical.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        2
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_FENCE_FRONTAL_TOP"
    },
    "archive-fence-horizontal": {
      "label": "Ограда архива — горизонтально",
      "path": "props/archive-fence-horizontal.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "occupiedSize": [
        14,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_ARCHIVE_SECURITY_FRONTAL_TOP"
    },
    "archive-fence-vertical": {
      "label": "Ограда архива — вертикально",
      "path": "props/archive-fence-vertical.png",
      "size": [
        8,
        16
      ],
      "footprintCells": [
        1,
        2
      ],
      "anchorPx": [
        4,
        16
      ],
      "occupiedSize": [
        6,
        15
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_ARCHIVE_SECURITY_FRONTAL_TOP"
    },
    "archive-security-barrier": {
      "label": "Шлагбаум архива",
      "path": "props/archive-security-barrier.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "occupiedSize": [
        14,
        7
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/terrain-fences-v1.png",
      "visualProfile": "TASKTOPIA_V5_ARCHIVE_SECURITY_FRONTAL_TOP"
    },
    "playground-small": {
      "label": "Дворовая игровая площадка",
      "path": "props/playground-small.png",
      "size": [
        24,
        16
      ],
      "footprintCells": [
        3,
        2
      ],
      "anchorPx": [
        12,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/playground-combination-v1.png",
      "visualProfile": "TASKTOPIA_V5_PLAYGROUND_FRONTAL_TOP"
    },
    "playground-slide": {
      "label": "Игровая горка",
      "path": "props/playground-slide.png",
      "size": [
        24,
        16
      ],
      "footprintCells": [
        3,
        2
      ],
      "anchorPx": [
        12,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/playground-slide-v1.png",
      "visualProfile": "TASKTOPIA_V5_PLAYGROUND_FRONTAL_TOP"
    },
    "playground-carousel": {
      "label": "Детская карусель",
      "path": "props/playground-carousel.png",
      "size": [
        32,
        24
      ],
      "footprintCells": [
        3,
        3
      ],
      "anchorPx": [
        16,
        24
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-frontal-core-v2.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "playground-climbing": {
      "label": "Лазательный комплекс",
      "path": "props/playground-climbing.png",
      "size": [
        24,
        24
      ],
      "footprintCells": [
        3,
        3
      ],
      "anchorPx": [
        12,
        24
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/playground-climbing-v1.png",
      "visualProfile": "TASKTOPIA_V5_PLAYGROUND_FRONTAL_TOP"
    },
    "playground-swing": {
      "label": "Двойные качели",
      "path": "props/playground-swing.png",
      "size": [
        24,
        24
      ],
      "footprintCells": [
        3,
        3
      ],
      "anchorPx": [
        12,
        24
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/playground-swing-v1.png",
      "visualProfile": "TASKTOPIA_V5_PLAYGROUND_FRONTAL_TOP"
    },
    "fountain-large": {
      "label": "Большой городской фонтан",
      "path": "props/fountain-large.png",
      "size": [
        32,
        32
      ],
      "footprintCells": [
        4,
        4
      ],
      "anchorPx": [
        16,
        32
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-frontal-core-v2.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "gazebo": {
      "label": "Парковая беседка",
      "path": "props/gazebo.png",
      "size": [
        32,
        32
      ],
      "footprintCells": [
        4,
        3
      ],
      "anchorPx": [
        16,
        32
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-frontal-core-v2.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-pond": {
      "label": "Пруд с мостиком",
      "path": "props/park-pond.png",
      "size": [
        32,
        24
      ],
      "footprintCells": [
        4,
        3
      ],
      "anchorPx": [
        16,
        24
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-pond-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-sculpture": {
      "label": "Парковая скульптура",
      "path": "props/park-sculpture.png",
      "size": [
        16,
        24
      ],
      "footprintCells": [
        2,
        3
      ],
      "anchorPx": [
        8,
        24
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-sculpture-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-flower-clock": {
      "label": "Цветочные часы",
      "path": "props/park-flower-clock.png",
      "size": [
        24,
        16
      ],
      "footprintCells": [
        3,
        2
      ],
      "anchorPx": [
        12,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-flower-clock-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "park-bandstand": {
      "label": "Парковая эстрада",
      "path": "props/park-bandstand.png",
      "size": [
        32,
        24
      ],
      "footprintCells": [
        4,
        3
      ],
      "anchorPx": [
        16,
        24
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/ambient/park-bandstand-v1.png",
      "visualProfile": "TASKTOPIA_V5_PARK_OBJECT_FRONTAL_TOP"
    },
    "tree-oak": {
      "label": "Дуб",
      "path": "props/tree-oak.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-oak.png"
    },
    "tree-maple": {
      "label": "Клён",
      "path": "props/tree-maple.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-maple.png"
    },
    "tree-round": {
      "label": "Городское дерево",
      "path": "props/tree-round.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-round.png"
    },
    "tree-aspen": {
      "label": "Осина",
      "path": "props/tree-aspen.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-aspen.png"
    },
    "tree-birch": {
      "label": "Берёза",
      "path": "props/tree-birch.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-birch.png"
    },
    "tree-apple": {
      "label": "Яблоня",
      "path": "props/tree-apple.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-apple.png"
    },
    "tree-cherry": {
      "label": "Цветущая вишня",
      "path": "props/tree-cherry.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-cherry.png"
    },
    "tree-magnolia": {
      "label": "Магнолия",
      "path": "props/tree-magnolia.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-magnolia.png"
    },
    "tree-willow": {
      "label": "Ива",
      "path": "props/tree-willow.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-willow.png"
    },
    "tree-deadwood": {
      "label": "Сухостой",
      "path": "props/tree-deadwood.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-deadwood.png"
    },
    "tree-conifer": {
      "label": "Ель",
      "path": "props/tree-conifer.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-conifer.png"
    },
    "tree-pine": {
      "label": "Сосна",
      "path": "props/tree-pine.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-pine.png"
    },
    "tree-cedar": {
      "label": "Кедр",
      "path": "props/tree-cedar.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-cedar.png"
    },
    "tree-cypress": {
      "label": "Кипарис",
      "path": "props/tree-cypress.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-cypress.png"
    },
    "tree-redwood": {
      "label": "Секвойя",
      "path": "props/tree-redwood.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-redwood.png"
    },
    "tree-palm": {
      "label": "Пальма",
      "path": "props/tree-palm.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        1,
        1
      ],
      "visualProfile": "TASKTOPIA_V7_TREE_COMPACT_45_GRID",
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-trees-v7/sources/tree-palm.png"
    },
    "compact-construction-crane": {
      "label": "Компактный строительный кран",
      "path": "props/compact-construction-crane.png",
      "size": [
        16,
        24
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        24
      ],
      "artSource": "PROCEDURAL_TILE_KIT",
      "visualProfile": "TASKTOPIA_V7_COMPACT_CONSTRUCTION_45"
    },
    "compact-construction-hut": {
      "label": "Компактная строительная бытовка",
      "path": "props/compact-construction-hut.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "artSource": "PROCEDURAL_TILE_KIT",
      "visualProfile": "TASKTOPIA_V7_COMPACT_CONSTRUCTION_45"
    },
    "compact-construction-bricks": {
      "label": "Поддон кирпича",
      "path": "props/compact-construction-bricks.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "artSource": "PROCEDURAL_TILE_KIT",
      "visualProfile": "TASKTOPIA_V7_COMPACT_CONSTRUCTION_45"
    },
    "compact-construction-sand": {
      "label": "Строительный песок",
      "path": "props/compact-construction-sand.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "artSource": "PROCEDURAL_TILE_KIT",
      "visualProfile": "TASKTOPIA_V7_COMPACT_CONSTRUCTION_45"
    },
    "compact-park-fountain-stage-3": {
      "label": "Фонтан · стадия 3",
      "path": "props/compact-park-fountain-stage-3.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-park-fountain-v1/sources/stage-3.png",
      "visualProfile": "TASKTOPIA_COMPACT_PARK_HIGH_45_V1"
    },
    "compact-park-fountain-stage-4": {
      "label": "Фонтан · стадия 4",
      "path": "props/compact-park-fountain-stage-4.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-park-fountain-v1/sources/stage-4.png",
      "visualProfile": "TASKTOPIA_COMPACT_PARK_HIGH_45_V1"
    },
    "compact-park-fountain-stage-5": {
      "label": "Фонтан · стадия 5",
      "path": "props/compact-park-fountain-stage-5.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-park-fountain-v1/sources/stage-5.png",
      "visualProfile": "TASKTOPIA_COMPACT_PARK_HIGH_45_V1"
    },
    "compact-park-monument-stage-3": {
      "label": "Памятник · стадия 3",
      "path": "props/compact-park-monument-stage-3.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-park-monument-v1/sources/stage-3.png",
      "visualProfile": "TASKTOPIA_COMPACT_PARK_HIGH_45_V1"
    },
    "compact-park-monument-stage-4": {
      "label": "Памятник · стадия 4",
      "path": "props/compact-park-monument-stage-4.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-park-monument-v1/sources/stage-4.png",
      "visualProfile": "TASKTOPIA_COMPACT_PARK_HIGH_45_V1"
    },
    "compact-park-monument-stage-5": {
      "label": "Памятник · стадия 5",
      "path": "props/compact-park-monument-stage-5.png",
      "size": [
        16,
        16
      ],
      "anchorPx": [
        8,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-park-monument-v1/sources/stage-5.png",
      "visualProfile": "TASKTOPIA_COMPACT_PARK_HIGH_45_V1"
    },
    "courtyard-picnic-table": {
      "label": "Дворовый стол со скамейками",
      "path": "props/courtyard-picnic-table.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-courtyard-furniture-v1/sources/courtyard-picnic-table.png",
      "visualProfile": "TASKTOPIA_COMPACT_COURTYARD_HIGH_45_V1"
    },
    "courtyard-square-planter": {
      "label": "Квадратная клумба во дворе",
      "path": "props/courtyard-square-planter.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-courtyard-furniture-v1/sources/courtyard-square-planter.png",
      "visualProfile": "TASKTOPIA_COMPACT_COURTYARD_HIGH_45_V1"
    },
    "courtyard-cycle-rack": {
      "label": "Компактная велопарковка",
      "path": "props/courtyard-cycle-rack.png",
      "size": [
        16,
        8
      ],
      "footprintCells": [
        2,
        1
      ],
      "anchorPx": [
        8,
        8
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/compact-courtyard-furniture-v1/sources/courtyard-cycle-rack.png",
      "visualProfile": "TASKTOPIA_COMPACT_COURTYARD_HIGH_45_V1"
    },
    "boat-vertical-c": {
      "label": "Буксир",
      "path": "props/boat-vertical-c.png",
      "size": [
        8,
        24
      ],
      "footprintCells": [
        1,
        3
      ],
      "anchorPx": [
        4,
        24
      ],
      "occupiedSize": [
        6,
        11
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "SOUTH"
    },
    "boat-horizontal-c": {
      "label": "Буксир",
      "path": "props/boat-horizontal-c.png",
      "size": [
        24,
        8
      ],
      "footprintCells": [
        3,
        1
      ],
      "anchorPx": [
        12,
        8
      ],
      "occupiedSize": [
        11,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "EAST"
    },
    "boat-vertical-d": {
      "label": "Парусная лодка",
      "path": "props/boat-vertical-d.png",
      "size": [
        8,
        24
      ],
      "footprintCells": [
        1,
        3
      ],
      "anchorPx": [
        4,
        24
      ],
      "occupiedSize": [
        6,
        13
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "SOUTH"
    },
    "boat-horizontal-d": {
      "label": "Парусная лодка",
      "path": "props/boat-horizontal-d.png",
      "size": [
        24,
        8
      ],
      "footprintCells": [
        3,
        1
      ],
      "anchorPx": [
        12,
        8
      ],
      "occupiedSize": [
        13,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/micro-ambient-v1/sources/boats-v2.png",
      "visualProfile": "TASKTOPIA_MICRO_WATERCRAFT_V2",
      "baseFacing": "EAST"
    },
    "district-development-active": {
      "label": "Обозначение района: active",
      "path": "props/district-development-active.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        8,
        16
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/district-development-v1/sources/active.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "district-development-planned": {
      "label": "Обозначение района: planned",
      "path": "props/district-development-planned.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        7,
        11
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/district-development-v1/sources/planned.png",
      "visualProfile": "TASKTOPIA_V5_STREET_FURNITURE_FRONTAL_TOP"
    },
    "compact-construction-worker-north-0": {
      "label": "compact-construction-worker-north-0",
      "path": "props/compact-construction-worker-north-0.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-east-0": {
      "label": "compact-construction-worker-east-0",
      "path": "props/compact-construction-worker-east-0.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-south-0": {
      "label": "compact-construction-worker-south-0",
      "path": "props/compact-construction-worker-south-0.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-west-0": {
      "label": "compact-construction-worker-west-0",
      "path": "props/compact-construction-worker-west-0.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-north-1": {
      "label": "compact-construction-worker-north-1",
      "path": "props/compact-construction-worker-north-1.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        5,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-east-1": {
      "label": "compact-construction-worker-east-1",
      "path": "props/compact-construction-worker-east-1.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        5,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-south-1": {
      "label": "compact-construction-worker-south-1",
      "path": "props/compact-construction-worker-south-1.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        5,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-construction-worker-west-1": {
      "label": "compact-construction-worker-west-1",
      "path": "props/compact-construction-worker-west-1.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        5,
        5
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/construction-worker-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_V5_MICRO_DIRECTIONAL"
    },
    "compact-cargo-helicopter-north": {
      "label": "compact-cargo-helicopter-north",
      "path": "props/compact-cargo-helicopter-north.png",
      "size": [
        32,
        32
      ],
      "footprintCells": [
        4,
        4
      ],
      "anchorPx": [
        16,
        32
      ],
      "occupiedSize": [
        12,
        19
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/cargo-helicopter-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_CARGO_HELICOPTER_TOPDOWN_V1",
      "direction": "north"
    },
    "compact-cargo-helicopter-east": {
      "label": "compact-cargo-helicopter-east",
      "path": "props/compact-cargo-helicopter-east.png",
      "size": [
        32,
        32
      ],
      "footprintCells": [
        4,
        4
      ],
      "anchorPx": [
        16,
        32
      ],
      "occupiedSize": [
        24,
        12
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/cargo-helicopter-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_CARGO_HELICOPTER_TOPDOWN_V1",
      "direction": "east"
    },
    "compact-cargo-helicopter-south": {
      "label": "compact-cargo-helicopter-south",
      "path": "props/compact-cargo-helicopter-south.png",
      "size": [
        32,
        32
      ],
      "footprintCells": [
        4,
        4
      ],
      "anchorPx": [
        16,
        32
      ],
      "occupiedSize": [
        12,
        19
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/cargo-helicopter-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_CARGO_HELICOPTER_TOPDOWN_V1",
      "direction": "south"
    },
    "compact-cargo-helicopter-west": {
      "label": "compact-cargo-helicopter-west",
      "path": "props/compact-cargo-helicopter-west.png",
      "size": [
        32,
        32
      ],
      "footprintCells": [
        4,
        4
      ],
      "anchorPx": [
        16,
        32
      ],
      "occupiedSize": [
        24,
        12
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/cargo-helicopter-v1/sources/sheet.png",
      "visualProfile": "TASKTOPIA_CARGO_HELICOPTER_TOPDOWN_V1",
      "direction": "west"
    },
    "city-event-bus-north": {
      "label": "city-event-bus-north",
      "path": "props/city-event-bus-north.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "north"
    },
    "city-event-bus-east": {
      "label": "city-event-bus-east",
      "path": "props/city-event-bus-east.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "east"
    },
    "city-event-bus-south": {
      "label": "city-event-bus-south",
      "path": "props/city-event-bus-south.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "south"
    },
    "city-event-bus-west": {
      "label": "city-event-bus-west",
      "path": "props/city-event-bus-west.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "west"
    },
    "city-event-school-bus-north": {
      "label": "city-event-school-bus-north",
      "path": "props/city-event-school-bus-north.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/school-bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "north"
    },
    "city-event-school-bus-east": {
      "label": "city-event-school-bus-east",
      "path": "props/city-event-school-bus-east.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/school-bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "east"
    },
    "city-event-school-bus-south": {
      "label": "city-event-school-bus-south",
      "path": "props/city-event-school-bus-south.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/school-bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "south"
    },
    "city-event-school-bus-west": {
      "label": "city-event-school-bus-west",
      "path": "props/city-event-school-bus-west.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/school-bus.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "west"
    },
    "city-event-tow-north": {
      "label": "city-event-tow-north",
      "path": "props/city-event-tow-north.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "north"
    },
    "city-event-tow-east": {
      "label": "city-event-tow-east",
      "path": "props/city-event-tow-east.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "east"
    },
    "city-event-tow-south": {
      "label": "city-event-tow-south",
      "path": "props/city-event-tow-south.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "south"
    },
    "city-event-tow-west": {
      "label": "city-event-tow-west",
      "path": "props/city-event-tow-west.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "west"
    },
    "city-event-tow-loaded-north": {
      "label": "city-event-tow-loaded-north",
      "path": "props/city-event-tow-loaded-north.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow-loaded.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "north"
    },
    "city-event-tow-loaded-east": {
      "label": "city-event-tow-loaded-east",
      "path": "props/city-event-tow-loaded-east.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow-loaded.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "east"
    },
    "city-event-tow-loaded-south": {
      "label": "city-event-tow-loaded-south",
      "path": "props/city-event-tow-loaded-south.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        4,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow-loaded.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "south"
    },
    "city-event-tow-loaded-west": {
      "label": "city-event-tow-loaded-west",
      "path": "props/city-event-tow-loaded-west.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        3
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/tow-loaded.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "west"
    },
    "city-event-market-stall": {
      "label": "city-event-market-stall",
      "path": "props/city-event-market-stall.png",
      "size": [
        16,
        16
      ],
      "footprintCells": [
        2,
        2
      ],
      "anchorPx": [
        8,
        16
      ],
      "occupiedSize": [
        14,
        11
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/market-stall.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "static"
    },
    "city-event-umbrella": {
      "label": "city-event-umbrella",
      "path": "props/city-event-umbrella.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        6,
        6
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/umbrella.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "static"
    },
    "city-event-child-north": {
      "label": "city-event-child-north",
      "path": "props/city-event-child-north.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        4
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/child-v2.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "north"
    },
    "city-event-child-east": {
      "label": "city-event-child-east",
      "path": "props/city-event-child-east.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        4
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/child-v2.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "east"
    },
    "city-event-child-south": {
      "label": "city-event-child-south",
      "path": "props/city-event-child-south.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        4
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/child-v2.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "south"
    },
    "city-event-child-west": {
      "label": "city-event-child-west",
      "path": "props/city-event-child-west.png",
      "size": [
        8,
        8
      ],
      "footprintCells": [
        1,
        1
      ],
      "anchorPx": [
        4,
        8
      ],
      "occupiedSize": [
        3,
        4
      ],
      "artSource": "AI_AUTHORED",
      "sourceSheet": "ai-authored/everyday-city-v1/sources/child-v2.png",
      "visualProfile": "TASKTOPIA_EVERYDAY_MICRO_V1",
      "direction": "west"
    }
  },
  "propAtlas": {
    "path": "atlas/props-v1.png",
    "size": [
      512,
      128
    ],
    "frames": {
      "bandstand": {
        "x": 1,
        "y": 1,
        "width": 40,
        "height": 32
      },
      "compact-cargo-helicopter-east": {
        "x": 42,
        "y": 1,
        "width": 32,
        "height": 32
      },
      "compact-cargo-helicopter-north": {
        "x": 75,
        "y": 1,
        "width": 32,
        "height": 32
      },
      "compact-cargo-helicopter-south": {
        "x": 108,
        "y": 1,
        "width": 32,
        "height": 32
      },
      "compact-cargo-helicopter-west": {
        "x": 141,
        "y": 1,
        "width": 32,
        "height": 32
      },
      "fountain-large": {
        "x": 174,
        "y": 1,
        "width": 32,
        "height": 32
      },
      "gazebo": {
        "x": 207,
        "y": 1,
        "width": 32,
        "height": 32
      },
      "park-bandstand": {
        "x": 240,
        "y": 1,
        "width": 32,
        "height": 24
      },
      "park-pond": {
        "x": 273,
        "y": 1,
        "width": 32,
        "height": 24
      },
      "playground-carousel": {
        "x": 306,
        "y": 1,
        "width": 32,
        "height": 24
      },
      "park-path-circle": {
        "x": 339,
        "y": 1,
        "width": 24,
        "height": 24
      },
      "playground-climbing": {
        "x": 364,
        "y": 1,
        "width": 24,
        "height": 24
      },
      "playground-swing": {
        "x": 389,
        "y": 1,
        "width": 24,
        "height": 24
      },
      "pond-small": {
        "x": 414,
        "y": 1,
        "width": 24,
        "height": 24
      },
      "compact-construction-crane": {
        "x": 439,
        "y": 1,
        "width": 16,
        "height": 24
      },
      "mountain-peak": {
        "x": 456,
        "y": 1,
        "width": 16,
        "height": 24
      },
      "park-sculpture": {
        "x": 473,
        "y": 1,
        "width": 16,
        "height": 24
      },
      "statue-abstract": {
        "x": 490,
        "y": 1,
        "width": 16,
        "height": 24
      },
      "statue-hero": {
        "x": 1,
        "y": 34,
        "width": 16,
        "height": 24
      },
      "boat-vertical-a": {
        "x": 18,
        "y": 34,
        "width": 8,
        "height": 24
      },
      "boat-vertical-b": {
        "x": 27,
        "y": 34,
        "width": 8,
        "height": 24
      },
      "boat-vertical-c": {
        "x": 36,
        "y": 34,
        "width": 8,
        "height": 24
      },
      "boat-vertical-d": {
        "x": 45,
        "y": 34,
        "width": 8,
        "height": 24
      },
      "flower-bed-vertical": {
        "x": 54,
        "y": 34,
        "width": 8,
        "height": 24
      },
      "park-bridge": {
        "x": 63,
        "y": 34,
        "width": 32,
        "height": 16
      },
      "mountain-ridge": {
        "x": 96,
        "y": 34,
        "width": 24,
        "height": 16
      },
      "park-bench-double": {
        "x": 121,
        "y": 34,
        "width": 24,
        "height": 16
      },
      "park-flower-clock": {
        "x": 146,
        "y": 34,
        "width": 24,
        "height": 16
      },
      "playground-slide": {
        "x": 171,
        "y": 34,
        "width": 24,
        "height": 16
      },
      "playground-small": {
        "x": 196,
        "y": 34,
        "width": 24,
        "height": 16
      },
      "bus-stop-horizontal": {
        "x": 221,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "bus-stop-vertical": {
        "x": 238,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "city-event-market-stall": {
        "x": 255,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "compact-park-fountain-stage-3": {
        "x": 272,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "compact-park-fountain-stage-4": {
        "x": 289,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "compact-park-fountain-stage-5": {
        "x": 306,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "compact-park-monument-stage-3": {
        "x": 323,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "compact-park-monument-stage-4": {
        "x": 340,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "compact-park-monument-stage-5": {
        "x": 357,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "courtyard-picnic-table": {
        "x": 374,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "district-development-active": {
        "x": 391,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "district-development-planned": {
        "x": 408,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "fountain-small": {
        "x": 425,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "hill-rocky": {
        "x": 442,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "hill-small": {
        "x": 459,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "picnic-table": {
        "x": 476,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "streetlamp-double": {
        "x": 493,
        "y": 34,
        "width": 16,
        "height": 16
      },
      "streetlamp-double-lit": {
        "x": 1,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "topiary-animal": {
        "x": 18,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-apple": {
        "x": 35,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-aspen": {
        "x": 52,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-birch": {
        "x": 69,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-cedar": {
        "x": 86,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-cherry": {
        "x": 103,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-conifer": {
        "x": 120,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-cypress": {
        "x": 137,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-deadwood": {
        "x": 154,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-flowering": {
        "x": 171,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-magnolia": {
        "x": 188,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-maple": {
        "x": 205,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-oak": {
        "x": 222,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-palm": {
        "x": 239,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-pine": {
        "x": 256,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-redwood": {
        "x": 273,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-round": {
        "x": 290,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "tree-willow": {
        "x": 307,
        "y": 59,
        "width": 16,
        "height": 16
      },
      "active-district-flag": {
        "x": 324,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "archive-fence-vertical": {
        "x": 333,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "bench-vertical": {
        "x": 342,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "city-sign-horizontal": {
        "x": 351,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "city-sign-vertical": {
        "x": 360,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "fence-vertical": {
        "x": 369,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "guardrail-vertical": {
        "x": 378,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "park-lamp": {
        "x": 387,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "park-lamp-lit": {
        "x": 396,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp": {
        "x": 405,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-festive": {
        "x": 414,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-festive-lit": {
        "x": 423,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-industrial": {
        "x": 432,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-industrial-lit": {
        "x": 441,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-lit": {
        "x": 450,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-modern": {
        "x": 459,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-modern-lit": {
        "x": 468,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-solar": {
        "x": 477,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-solar-lit": {
        "x": 486,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-vintage": {
        "x": 495,
        "y": 59,
        "width": 8,
        "height": 16
      },
      "streetlamp-vintage-lit": {
        "x": 1,
        "y": 76,
        "width": 8,
        "height": 16
      },
      "topiary-spiral": {
        "x": 10,
        "y": 76,
        "width": 8,
        "height": 16
      },
      "traffic-light-green": {
        "x": 19,
        "y": 76,
        "width": 8,
        "height": 16
      },
      "traffic-light-red": {
        "x": 28,
        "y": 76,
        "width": 8,
        "height": 16
      },
      "utility-pole": {
        "x": 37,
        "y": 76,
        "width": 8,
        "height": 16
      },
      "boat-horizontal-a": {
        "x": 46,
        "y": 76,
        "width": 24,
        "height": 8
      },
      "boat-horizontal-b": {
        "x": 71,
        "y": 76,
        "width": 24,
        "height": 8
      },
      "boat-horizontal-c": {
        "x": 96,
        "y": 76,
        "width": 24,
        "height": 8
      },
      "boat-horizontal-d": {
        "x": 121,
        "y": 76,
        "width": 24,
        "height": 8
      },
      "flower-bed-horizontal": {
        "x": 146,
        "y": 76,
        "width": 24,
        "height": 8
      },
      "archive-fence-horizontal": {
        "x": 171,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "archive-security-barrier": {
        "x": 188,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "bench-horizontal": {
        "x": 205,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "bicycle-rack": {
        "x": 222,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "compact-construction-hut": {
        "x": 239,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "courtyard-cycle-rack": {
        "x": 256,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "fence-horizontal": {
        "x": 273,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "guardrail-horizontal": {
        "x": 290,
        "y": 76,
        "width": 16,
        "height": 8
      },
      "bollard": {
        "x": 307,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-bus-east": {
        "x": 316,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-bus-north": {
        "x": 325,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-bus-south": {
        "x": 334,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-bus-west": {
        "x": 343,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-child-east": {
        "x": 352,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-child-north": {
        "x": 361,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-child-south": {
        "x": 370,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-child-west": {
        "x": 379,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-school-bus-east": {
        "x": 388,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-school-bus-north": {
        "x": 397,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-school-bus-south": {
        "x": 406,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-school-bus-west": {
        "x": 415,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-east": {
        "x": 424,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-loaded-east": {
        "x": 433,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-loaded-north": {
        "x": 442,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-loaded-south": {
        "x": 451,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-loaded-west": {
        "x": 460,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-north": {
        "x": 469,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-south": {
        "x": 478,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-tow-west": {
        "x": 487,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "city-event-umbrella": {
        "x": 496,
        "y": 76,
        "width": 8,
        "height": 8
      },
      "compact-construction-bricks": {
        "x": 1,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-sand": {
        "x": 10,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-east-0": {
        "x": 19,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-east-1": {
        "x": 28,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-north-0": {
        "x": 37,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-north-1": {
        "x": 46,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-south-0": {
        "x": 55,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-south-1": {
        "x": 64,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-west-0": {
        "x": 73,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "compact-construction-worker-west-1": {
        "x": 82,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "courtyard-square-planter": {
        "x": 91,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "fire-hydrant": {
        "x": 100,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "flower-pink": {
        "x": 109,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "flower-white": {
        "x": 118,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "flower-yellow": {
        "x": 127,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "mailbox": {
        "x": 136,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "planter-round": {
        "x": 145,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "recycling-bin": {
        "x": 154,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "shrub-flowering": {
        "x": 163,
        "y": 93,
        "width": 8,
        "height": 8
      },
      "trash-bin": {
        "x": 172,
        "y": 93,
        "width": 8,
        "height": 8
      }
    }
  },
  "assetRevision": "f5ba91abe09a928b",
  "buildingProfile": "TASKTOPIA_COMPACT_CARTOON_HIGH_45_V1",
  "microAmbient": {
    "schemaVersion": 1,
    "visualProfile": "TASKTOPIA_MICRO_TOPDOWN_CARTOON_V1",
    "cellSizePx": 8,
    "artSource": "AI_AUTHORED",
    "sources": {
      "cars": {
        "path": "reference/ai-authored/micro-ambient-v1/sources/cars.png",
        "sha256": "1a03955a49b400bac169fc5d832ee1ddc230340fa15569bde927246b2c4a7a5c",
        "grid": [
          4,
          4
        ]
      },
      "cars-extra": {
        "path": "reference/ai-authored/micro-ambient-v1/sources/cars-extra-v2.png",
        "sha256": "ee27db1f7921dc16ce82a974d3e6264b0bdedde18718392d32b5ea6c143c6f2e",
        "grid": [
          4,
          4
        ]
      },
      "people": {
        "path": "reference/ai-authored/micro-ambient-v1/sources/people-v2.png",
        "sha256": "bba0f57e1884fabbd553ecd0f82ce2d86a8ef240706e999441b19d9e634de52b",
        "grid": [
          2,
          4
        ],
        "revision": 2,
        "provenance": "reference/ai-authored/micro-ambient-v1/people-v2-provenance.json"
      },
      "animals": {
        "path": "reference/ai-authored/micro-ambient-v1/sources/animals-directions-v2.png",
        "sha256": "5ba13bba795c0a0c99f2f133286550121f157bcd57a801533973df9684ebb5c9",
        "grid": [
          8,
          4
        ]
      },
      "aircraft": {
        "path": "reference/ai-authored/micro-ambient-v1/sources/aircraft.png",
        "sha256": "249d483594d7f407c78781a4c2022c4e8db0e10a4b0e4c9111a5e32f5533ac67",
        "grid": [
          2,
          2
        ]
      }
    },
    "sprites": {
      "micro-car-blue-north": {
        "path": "micro-ambient/micro-car-blue-north.png",
        "kind": "car",
        "variant": "blue",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          0,
          0
        ],
        "sourceCellBounds": [
          0,
          0,
          318,
          309
        ],
        "sha256": "23c2fbf9acb552a2f9f5c27778b51317b7ffdf3fb58db837f87aa7331b6f5191"
      },
      "micro-car-red-north": {
        "path": "micro-ambient/micro-car-red-north.png",
        "kind": "car",
        "variant": "red",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          1,
          0
        ],
        "sourceCellBounds": [
          318,
          0,
          637,
          309
        ],
        "sha256": "2c34b0677a3de9d16cb5f8b1ba90c143d3e689aac33400162e9dd3950ab11e34"
      },
      "micro-car-taxi-north": {
        "path": "micro-ambient/micro-car-taxi-north.png",
        "kind": "car",
        "variant": "taxi",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          2,
          0
        ],
        "sourceCellBounds": [
          637,
          0,
          956,
          309
        ],
        "sha256": "d03c9c661b75a0521bf319779b897b4c043f447887ebd233332abd031e155918"
      },
      "micro-car-van-north": {
        "path": "micro-ambient/micro-car-van-north.png",
        "kind": "car",
        "variant": "van",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          3,
          0
        ],
        "sourceCellBounds": [
          956,
          0,
          1274,
          309
        ],
        "sha256": "3ce8136c6f355979dc182f272450f99538b9e6014c1c645fd95722737ec565ec"
      },
      "micro-car-blue-east": {
        "path": "micro-ambient/micro-car-blue-east.png",
        "kind": "car",
        "variant": "blue",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          0,
          1
        ],
        "sourceCellBounds": [
          0,
          309,
          318,
          618
        ],
        "sha256": "69ba74a4f58eebc2df0925318967e4abb5382c953c300695f50e087d8663632c"
      },
      "micro-car-red-east": {
        "path": "micro-ambient/micro-car-red-east.png",
        "kind": "car",
        "variant": "red",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          1,
          1
        ],
        "sourceCellBounds": [
          318,
          309,
          637,
          618
        ],
        "sha256": "68ab2161404ff4b0cb4bc549ead589dd4d864385ca9249bf2fcd0e4a9fa6e3a9"
      },
      "micro-car-taxi-east": {
        "path": "micro-ambient/micro-car-taxi-east.png",
        "kind": "car",
        "variant": "taxi",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          2,
          1
        ],
        "sourceCellBounds": [
          637,
          309,
          956,
          618
        ],
        "sha256": "593e91069d4bb3ecfbc0088f7c4cfa9ddcd60378e40fb775f03f622857815c6e"
      },
      "micro-car-van-east": {
        "path": "micro-ambient/micro-car-van-east.png",
        "kind": "car",
        "variant": "van",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          3,
          1
        ],
        "sourceCellBounds": [
          956,
          309,
          1274,
          618
        ],
        "sha256": "2e9093007a292abc1bdcc81d96b8f9a3061a0c32178b7723e386035f32625395"
      },
      "micro-car-blue-south": {
        "path": "micro-ambient/micro-car-blue-south.png",
        "kind": "car",
        "variant": "blue",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          0,
          2
        ],
        "sourceCellBounds": [
          0,
          618,
          318,
          926
        ],
        "sha256": "1c74d148ed348c7e447858d2f92418837b16809c2aac445cfb31ed53f5999196"
      },
      "micro-car-red-south": {
        "path": "micro-ambient/micro-car-red-south.png",
        "kind": "car",
        "variant": "red",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          1,
          2
        ],
        "sourceCellBounds": [
          318,
          618,
          637,
          926
        ],
        "sha256": "ec1f60dd4034f3a9ef7591ce934e3a02eb6d301f62b5a08b09f97275cd5b78bf"
      },
      "micro-car-taxi-south": {
        "path": "micro-ambient/micro-car-taxi-south.png",
        "kind": "car",
        "variant": "taxi",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          2,
          2
        ],
        "sourceCellBounds": [
          637,
          618,
          956,
          926
        ],
        "sha256": "2a380f72f5090fae68ce1f52b2cf552127fc27455b1efc5bede786110759370c"
      },
      "micro-car-van-south": {
        "path": "micro-ambient/micro-car-van-south.png",
        "kind": "car",
        "variant": "van",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          3,
          2
        ],
        "sourceCellBounds": [
          956,
          618,
          1274,
          926
        ],
        "sha256": "f999f9698ac9d84ffda2efafce7d80db763f21477af68f6855e0589182dca49a"
      },
      "micro-car-blue-west": {
        "path": "micro-ambient/micro-car-blue-west.png",
        "kind": "car",
        "variant": "blue",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          0,
          3
        ],
        "sourceCellBounds": [
          0,
          926,
          318,
          1235
        ],
        "sha256": "f943422a557ee8c11ef1228bbaf79eef2e1628378b1b5a1e89c321b3a387e960"
      },
      "micro-car-red-west": {
        "path": "micro-ambient/micro-car-red-west.png",
        "kind": "car",
        "variant": "red",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          1,
          3
        ],
        "sourceCellBounds": [
          318,
          926,
          637,
          1235
        ],
        "sha256": "d524c80ac0d63a4ff893eadaddfbe18f9675150824ffa00caad154fddcfd2435"
      },
      "micro-car-taxi-west": {
        "path": "micro-ambient/micro-car-taxi-west.png",
        "kind": "car",
        "variant": "taxi",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          2,
          3
        ],
        "sourceCellBounds": [
          637,
          926,
          956,
          1235
        ],
        "sha256": "117cf36f911a5897a588182b039a87818d6bce69f79c63e92ec5b4c58364d7ed"
      },
      "micro-car-van-west": {
        "path": "micro-ambient/micro-car-van-west.png",
        "kind": "car",
        "variant": "van",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars",
        "sourceCell": [
          3,
          3
        ],
        "sourceCellBounds": [
          956,
          926,
          1274,
          1235
        ],
        "sha256": "c85f3f485aa969f14779d3b81d6fc35aa5037082225e1f5c178ec9cde42a3617"
      },
      "micro-car-pickup-north": {
        "path": "micro-ambient/micro-car-pickup-north.png",
        "kind": "car",
        "variant": "pickup",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          0,
          0
        ],
        "sourceCellBounds": [
          0,
          0,
          314,
          314
        ],
        "sha256": "665f97ad1f14ae2fa28997a674e3f5f7026a009c27011b2757546a2197332e0c"
      },
      "micro-car-minibus-north": {
        "path": "micro-ambient/micro-car-minibus-north.png",
        "kind": "car",
        "variant": "minibus",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          1,
          0
        ],
        "sourceCellBounds": [
          314,
          0,
          627,
          314
        ],
        "sha256": "95fab6035b1844822e3422684328f4c357299e667cf36763d18af177e97bb205"
      },
      "micro-car-hatchback-north": {
        "path": "micro-ambient/micro-car-hatchback-north.png",
        "kind": "car",
        "variant": "hatchback",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          2,
          0
        ],
        "sourceCellBounds": [
          627,
          0,
          940,
          314
        ],
        "sha256": "9425e3047467a7d4d5901d8fe1ffe30c913ea645dbb56bcf0831d12ad74e7bfc"
      },
      "micro-car-delivery-north": {
        "path": "micro-ambient/micro-car-delivery-north.png",
        "kind": "car",
        "variant": "delivery",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          3,
          0
        ],
        "sourceCellBounds": [
          940,
          0,
          1254,
          314
        ],
        "sha256": "40591329f53f790feee7bd8c7eb1794dfa475e6c7f4e37646bba622c66b1a2bb"
      },
      "micro-car-pickup-west": {
        "path": "micro-ambient/micro-car-pickup-west.png",
        "kind": "car",
        "variant": "pickup",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          0,
          1
        ],
        "sourceCellBounds": [
          0,
          314,
          314,
          627
        ],
        "sha256": "5f66a92dfb6abfdf7c4a09f58587c2472d9ed6da91fa01ec408692125609a4d4"
      },
      "micro-car-minibus-west": {
        "path": "micro-ambient/micro-car-minibus-west.png",
        "kind": "car",
        "variant": "minibus",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          1,
          1
        ],
        "sourceCellBounds": [
          314,
          314,
          627,
          627
        ],
        "sha256": "f78c8352690b5719ee4f6bd114f81184ad43447d88ea98570bb78de5b993bf96"
      },
      "micro-car-hatchback-west": {
        "path": "micro-ambient/micro-car-hatchback-west.png",
        "kind": "car",
        "variant": "hatchback",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          2,
          1
        ],
        "sourceCellBounds": [
          627,
          314,
          940,
          627
        ],
        "sha256": "cb141219f5e2ff5a25b2c2c93f5ab6fa7d1930e97a573665e1d28d593642b262"
      },
      "micro-car-delivery-west": {
        "path": "micro-ambient/micro-car-delivery-west.png",
        "kind": "car",
        "variant": "delivery",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          4,
          6,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          3,
          1
        ],
        "sourceCellBounds": [
          940,
          314,
          1254,
          627
        ],
        "sha256": "9e230ed8f6c7ef1f9963a788f871d91b38d6f0184f3862f535e1476fb2da8fd3"
      },
      "micro-car-pickup-south": {
        "path": "micro-ambient/micro-car-pickup-south.png",
        "kind": "car",
        "variant": "pickup",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          0,
          2
        ],
        "sourceCellBounds": [
          0,
          627,
          314,
          940
        ],
        "sha256": "3ceeedf67c0a7f86c89c3357c5f055abd53f1c2f710f7ba519c7bec0b42d997b"
      },
      "micro-car-minibus-south": {
        "path": "micro-ambient/micro-car-minibus-south.png",
        "kind": "car",
        "variant": "minibus",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          1,
          2
        ],
        "sourceCellBounds": [
          314,
          627,
          627,
          940
        ],
        "sha256": "c7185e009e716305bd4e210658fe9c9e5069cffdd0a9f49dfdb91989a40687e1"
      },
      "micro-car-hatchback-south": {
        "path": "micro-ambient/micro-car-hatchback-south.png",
        "kind": "car",
        "variant": "hatchback",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          2,
          2
        ],
        "sourceCellBounds": [
          627,
          627,
          940,
          940
        ],
        "sha256": "08b60e772b1da1d4f23eeeffbb606aa4e59e6a387d240782e6ea77855aa55ff2"
      },
      "micro-car-delivery-south": {
        "path": "micro-ambient/micro-car-delivery-south.png",
        "kind": "car",
        "variant": "delivery",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          3,
          2
        ],
        "sourceCellBounds": [
          940,
          627,
          1254,
          940
        ],
        "sha256": "03cb1d905e8465a477c4f0f5bf6586921e6bd6d573d3845c26da8483ca365765"
      },
      "micro-car-pickup-east": {
        "path": "micro-ambient/micro-car-pickup-east.png",
        "kind": "car",
        "variant": "pickup",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          0,
          3
        ],
        "sourceCellBounds": [
          0,
          940,
          314,
          1254
        ],
        "sha256": "8e5a8d1130ae5a39b0655cb2d885623ead782dbb211bec5f6444e483f0b8af8e"
      },
      "micro-car-minibus-east": {
        "path": "micro-ambient/micro-car-minibus-east.png",
        "kind": "car",
        "variant": "minibus",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          1,
          3
        ],
        "sourceCellBounds": [
          314,
          940,
          627,
          1254
        ],
        "sha256": "e04fae6f94d0de16917ffbf0db8024c79d5ebf71b74150d2e40d62a52144a113"
      },
      "micro-car-hatchback-east": {
        "path": "micro-ambient/micro-car-hatchback-east.png",
        "kind": "car",
        "variant": "hatchback",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          2,
          3
        ],
        "sourceCellBounds": [
          627,
          940,
          940,
          1254
        ],
        "sha256": "5c631e6bbcd64e6a0c465c77a155abf102d45f462377536a1f3bd2c903ed6056"
      },
      "micro-car-delivery-east": {
        "path": "micro-ambient/micro-car-delivery-east.png",
        "kind": "car",
        "variant": "delivery",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          7,
          5
        ],
        "frameCount": 1,
        "sourceFamily": "cars-extra",
        "sourceCell": [
          3,
          3
        ],
        "sourceCellBounds": [
          940,
          940,
          1254,
          1254
        ],
        "sha256": "a0cdd715805d292a2fd2cfd8b49f261da695843b1e56740a332c39370e6afb58"
      },
      "micro-person-ochre-north": {
        "path": "micro-ambient/micro-person-ochre-north.png",
        "kind": "person",
        "variant": "ochre",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          0,
          0
        ],
        "sourceCellBounds": [
          0,
          0,
          256,
          288
        ],
        "sha256": "2b735250a448f37082b1d06a525bf3317dc38e1ec5e3426a4472dbcd6e23dd99"
      },
      "micro-person-teal-north": {
        "path": "micro-ambient/micro-person-teal-north.png",
        "kind": "person",
        "variant": "teal",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          1,
          0
        ],
        "sourceCellBounds": [
          256,
          0,
          512,
          288
        ],
        "sha256": "e4a74067adc98a09647effe0430c9dec33ce8e30adfed1c898f064a440698551"
      },
      "micro-person-ochre-east": {
        "path": "micro-ambient/micro-person-ochre-east.png",
        "kind": "person",
        "variant": "ochre",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          0,
          1
        ],
        "sourceCellBounds": [
          0,
          288,
          256,
          576
        ],
        "sha256": "1bdbfa3a664b11946cf68f57a32ad869a46a314329a3c701f79a0d1b5a53e5eb"
      },
      "micro-person-teal-east": {
        "path": "micro-ambient/micro-person-teal-east.png",
        "kind": "person",
        "variant": "teal",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          1,
          1
        ],
        "sourceCellBounds": [
          256,
          288,
          512,
          576
        ],
        "sha256": "54f4eaa92363b7575a16dd3d333c7e22baa8749c4bbcd0dd4638ac7960c1d753"
      },
      "micro-person-ochre-south": {
        "path": "micro-ambient/micro-person-ochre-south.png",
        "kind": "person",
        "variant": "ochre",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          0,
          2
        ],
        "sourceCellBounds": [
          0,
          576,
          256,
          864
        ],
        "sha256": "1b8506ac656c49fb367efd82974f2dc12663204b5ef65ddbce47f5fd81978348"
      },
      "micro-person-teal-south": {
        "path": "micro-ambient/micro-person-teal-south.png",
        "kind": "person",
        "variant": "teal",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          1,
          2
        ],
        "sourceCellBounds": [
          256,
          576,
          512,
          864
        ],
        "sha256": "cfd48742abf0e6416848f4c92fd331b961fbbc615bf131212844cdeb3a48c379"
      },
      "micro-person-ochre-west": {
        "path": "micro-ambient/micro-person-ochre-west.png",
        "kind": "person",
        "variant": "ochre",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          0,
          3
        ],
        "sourceCellBounds": [
          0,
          864,
          256,
          1152
        ],
        "sha256": "fee438218661946bc3f1440cb7a75aa9d7053e1bbad9a8319f8462850998f336"
      },
      "micro-person-teal-west": {
        "path": "micro-ambient/micro-person-teal-west.png",
        "kind": "person",
        "variant": "teal",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          2,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "people",
        "sourceCell": [
          1,
          3
        ],
        "sourceCellBounds": [
          256,
          864,
          512,
          1152
        ],
        "sha256": "4f7c575eba131c7d5a4ccbb4f0542a731ca82636481479a98536cae7e8c5c08e"
      },
      "micro-animal-fox-north": {
        "path": "micro-ambient/micro-animal-fox-north.png",
        "kind": "animal",
        "variant": "fox",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          0,
          0
        ],
        "sourceCellBounds": [
          0,
          0,
          222,
          222
        ],
        "sha256": "27a0c04794c4e70c5ab52d4873400ae237731f7b8077a4f5919a2d70ba9537d7"
      },
      "micro-animal-deer-north": {
        "path": "micro-ambient/micro-animal-deer-north.png",
        "kind": "animal",
        "variant": "deer",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          1,
          0
        ],
        "sourceCellBounds": [
          222,
          0,
          444,
          222
        ],
        "sha256": "5fbc2ad69e96d27b015eb7d252a25cabc49dc7de20dbc7d29e069ac86379acb1"
      },
      "micro-animal-rabbit-north": {
        "path": "micro-ambient/micro-animal-rabbit-north.png",
        "kind": "animal",
        "variant": "rabbit",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          2,
          0
        ],
        "sourceCellBounds": [
          444,
          0,
          665,
          222
        ],
        "sha256": "95c8dc786deb68db8362b47d9e38737f67dd1bcd3eec0a15e477b4d855a14201"
      },
      "micro-animal-boar-north": {
        "path": "micro-ambient/micro-animal-boar-north.png",
        "kind": "animal",
        "variant": "boar",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          3,
          0
        ],
        "sourceCellBounds": [
          665,
          0,
          887,
          222
        ],
        "sha256": "a619b7c3304a69d9da9daf1d54b5b348a454c60075353ffb0be1866867af07f3"
      },
      "micro-animal-duck-north": {
        "path": "micro-ambient/micro-animal-duck-north.png",
        "kind": "animal",
        "variant": "duck",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          4,
          0
        ],
        "sourceCellBounds": [
          887,
          0,
          1109,
          222
        ],
        "sha256": "36a29a3bcd98378a036174ad2de189ff20f4210787317d763353c7790073b4d0"
      },
      "micro-animal-sheep-north": {
        "path": "micro-ambient/micro-animal-sheep-north.png",
        "kind": "animal",
        "variant": "sheep",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          5,
          0
        ],
        "sourceCellBounds": [
          1109,
          0,
          1330,
          222
        ],
        "sha256": "50ba1e3fe1814f646012b07e6aee409201045f85514b14ecc41f47920ea345d4"
      },
      "micro-animal-dog-north": {
        "path": "micro-ambient/micro-animal-dog-north.png",
        "kind": "animal",
        "variant": "dog",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          6,
          0
        ],
        "sourceCellBounds": [
          1330,
          0,
          1552,
          222
        ],
        "sha256": "c9fbddba8644c68f176b9e379637f584061209d22f75920f20d7baef5c2bb96d"
      },
      "micro-animal-cat-north": {
        "path": "micro-ambient/micro-animal-cat-north.png",
        "kind": "animal",
        "variant": "cat",
        "direction": "north",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          7,
          0
        ],
        "sourceCellBounds": [
          1552,
          0,
          1774,
          222
        ],
        "sha256": "98efc98e78054b02c604e61ebe19e0244f05b1b20c69278c7a93801fdfff93c8"
      },
      "micro-animal-fox-east": {
        "path": "micro-ambient/micro-animal-fox-east.png",
        "kind": "animal",
        "variant": "fox",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          3,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          0,
          1
        ],
        "sourceCellBounds": [
          0,
          222,
          222,
          444
        ],
        "sha256": "fd1cd1c3725c4e13bbbd66952a34b28e1fae512a4ccf248fd497ad5e41cf311a"
      },
      "micro-animal-deer-east": {
        "path": "micro-ambient/micro-animal-deer-east.png",
        "kind": "animal",
        "variant": "deer",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          1,
          1
        ],
        "sourceCellBounds": [
          222,
          222,
          444,
          444
        ],
        "sha256": "575cce9281bc3f36cdc2e1d3fe87fd214ade4205edc1255735eaee0c9ad37061"
      },
      "micro-animal-rabbit-east": {
        "path": "micro-ambient/micro-animal-rabbit-east.png",
        "kind": "animal",
        "variant": "rabbit",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          2,
          1
        ],
        "sourceCellBounds": [
          444,
          222,
          665,
          444
        ],
        "sha256": "f516380df85547ceaa622a90dc6d8835c0831da9cbd3bc415e485fc3df2ce5f5"
      },
      "micro-animal-boar-east": {
        "path": "micro-ambient/micro-animal-boar-east.png",
        "kind": "animal",
        "variant": "boar",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          3,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          3,
          1
        ],
        "sourceCellBounds": [
          665,
          222,
          887,
          444
        ],
        "sha256": "2a74a891697e9788d4502eb11bd069836de18578e6b277f058ecf29efe44d9df"
      },
      "micro-animal-duck-east": {
        "path": "micro-ambient/micro-animal-duck-east.png",
        "kind": "animal",
        "variant": "duck",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          4,
          1
        ],
        "sourceCellBounds": [
          887,
          222,
          1109,
          444
        ],
        "sha256": "74a6a8ab0d31ff07397a4eebfb23df6ad9b0a3ab6b3a85ed3033bc84c4095781"
      },
      "micro-animal-sheep-east": {
        "path": "micro-ambient/micro-animal-sheep-east.png",
        "kind": "animal",
        "variant": "sheep",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          3,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          5,
          1
        ],
        "sourceCellBounds": [
          1109,
          222,
          1330,
          444
        ],
        "sha256": "6acdb2376ecb8165557676dcdc283e00ac3bc40c81782b68dae45f8dfcf6f2a0"
      },
      "micro-animal-dog-east": {
        "path": "micro-ambient/micro-animal-dog-east.png",
        "kind": "animal",
        "variant": "dog",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          6,
          1
        ],
        "sourceCellBounds": [
          1330,
          222,
          1552,
          444
        ],
        "sha256": "5851c8e088e5ba6df584cd522657c50d282aa7b5aaaa8088ca4feeab97382b00"
      },
      "micro-animal-cat-east": {
        "path": "micro-ambient/micro-animal-cat-east.png",
        "kind": "animal",
        "variant": "cat",
        "direction": "east",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          3,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          7,
          1
        ],
        "sourceCellBounds": [
          1552,
          222,
          1774,
          444
        ],
        "sha256": "fb1d181a8a4084e0113445737af6e3c5c455e70e81434fd693e4e5ff98fa5baa"
      },
      "micro-animal-fox-south": {
        "path": "micro-ambient/micro-animal-fox-south.png",
        "kind": "animal",
        "variant": "fox",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          0,
          2
        ],
        "sourceCellBounds": [
          0,
          444,
          222,
          665
        ],
        "sha256": "0cbe31636e1b2905f0cc713eefbe95e8570fe7d70025d19c557ca24c504b9666"
      },
      "micro-animal-deer-south": {
        "path": "micro-ambient/micro-animal-deer-south.png",
        "kind": "animal",
        "variant": "deer",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          1,
          2
        ],
        "sourceCellBounds": [
          222,
          444,
          444,
          665
        ],
        "sha256": "9a62155c05616550295f9907c295871984335ce0679a5e16c58455081dc8fc41"
      },
      "micro-animal-rabbit-south": {
        "path": "micro-ambient/micro-animal-rabbit-south.png",
        "kind": "animal",
        "variant": "rabbit",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          2,
          2
        ],
        "sourceCellBounds": [
          444,
          444,
          665,
          665
        ],
        "sha256": "c9daf238c95655842d3fa693d0fa99a2e05ece0e98c4229d06adcdf9489e3d49"
      },
      "micro-animal-boar-south": {
        "path": "micro-ambient/micro-animal-boar-south.png",
        "kind": "animal",
        "variant": "boar",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          3,
          2
        ],
        "sourceCellBounds": [
          665,
          444,
          887,
          665
        ],
        "sha256": "91eafa01506c95ce127f43a425553b7cc7e8fc370d2115e832672e68825bea18"
      },
      "micro-animal-duck-south": {
        "path": "micro-ambient/micro-animal-duck-south.png",
        "kind": "animal",
        "variant": "duck",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          4,
          2
        ],
        "sourceCellBounds": [
          887,
          444,
          1109,
          665
        ],
        "sha256": "6e86e0a41826ca5375b2efbb71965b2ab4b92c1d36dd3cf06df5a77664decaa7"
      },
      "micro-animal-sheep-south": {
        "path": "micro-ambient/micro-animal-sheep-south.png",
        "kind": "animal",
        "variant": "sheep",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          5,
          2
        ],
        "sourceCellBounds": [
          1109,
          444,
          1330,
          665
        ],
        "sha256": "5a4f0db4efe2736edfc21028b9a8c62f89791c70c245c4e3d315fb4c0a878a79"
      },
      "micro-animal-dog-south": {
        "path": "micro-ambient/micro-animal-dog-south.png",
        "kind": "animal",
        "variant": "dog",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          6,
          2
        ],
        "sourceCellBounds": [
          1330,
          444,
          1552,
          665
        ],
        "sha256": "a7768e95d23d3bafa5ce5c9be992cf0ae08d5b01ad3c689e2a7dfa8e5c1c874f"
      },
      "micro-animal-cat-south": {
        "path": "micro-ambient/micro-animal-cat-south.png",
        "kind": "animal",
        "variant": "cat",
        "direction": "south",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          2,
          1,
          5,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          7,
          2
        ],
        "sourceCellBounds": [
          1552,
          444,
          1774,
          665
        ],
        "sha256": "32ff267c9d461832148f81b230117b9ec7f2852ee76c2d1c579c23326c0a95cd"
      },
      "micro-animal-fox-west": {
        "path": "micro-ambient/micro-animal-fox-west.png",
        "kind": "animal",
        "variant": "fox",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          0,
          3
        ],
        "sourceCellBounds": [
          0,
          665,
          222,
          887
        ],
        "sha256": "8f9728437fa31f3def4ee598d5300f16c4d649a2de4dfa17c68b938338399d0c"
      },
      "micro-animal-deer-west": {
        "path": "micro-ambient/micro-animal-deer-west.png",
        "kind": "animal",
        "variant": "deer",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          6,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          1,
          3
        ],
        "sourceCellBounds": [
          222,
          665,
          444,
          887
        ],
        "sha256": "d98b668eda2628754aad925358078301b1c7471f54508d10b8c3c8e099e2aaca"
      },
      "micro-animal-rabbit-west": {
        "path": "micro-ambient/micro-animal-rabbit-west.png",
        "kind": "animal",
        "variant": "rabbit",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          7
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          2,
          3
        ],
        "sourceCellBounds": [
          444,
          665,
          665,
          887
        ],
        "sha256": "b421068ef89ab2e6bfcb00f6f1c3ee637d44303ff618c4df4414de637d6c4388"
      },
      "micro-animal-boar-west": {
        "path": "micro-ambient/micro-animal-boar-west.png",
        "kind": "animal",
        "variant": "boar",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          2,
          6,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          3,
          3
        ],
        "sourceCellBounds": [
          665,
          665,
          887,
          887
        ],
        "sha256": "14ecddd18ae017346d69bdd2c4034128aa404c2dd74c259acd9e1dc048853ebb"
      },
      "micro-animal-duck-west": {
        "path": "micro-ambient/micro-animal-duck-west.png",
        "kind": "animal",
        "variant": "duck",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          4,
          3
        ],
        "sourceCellBounds": [
          887,
          665,
          1109,
          887
        ],
        "sha256": "f8da27a63040520a69690f81f74baf03f0a52b9a9eecfbc4025f05612286a847"
      },
      "micro-animal-sheep-west": {
        "path": "micro-ambient/micro-animal-sheep-west.png",
        "kind": "animal",
        "variant": "sheep",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          5,
          3
        ],
        "sourceCellBounds": [
          1109,
          665,
          1330,
          887
        ],
        "sha256": "43876fbe51fdbe8185991c43f942450aa82806be001270ba8931eac85b493458"
      },
      "micro-animal-dog-west": {
        "path": "micro-ambient/micro-animal-dog-west.png",
        "kind": "animal",
        "variant": "dog",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          6,
          3
        ],
        "sourceCellBounds": [
          1330,
          665,
          1552,
          887
        ],
        "sha256": "a008e671752068fa4ae618abe935dbcbb37aa4bb914bf19ca6b55a3ff482afe5"
      },
      "micro-animal-cat-west": {
        "path": "micro-ambient/micro-animal-cat-west.png",
        "kind": "animal",
        "variant": "cat",
        "direction": "west",
        "size": [
          8,
          8
        ],
        "anchorPx": [
          4,
          4
        ],
        "opaqueBounds": [
          1,
          1,
          7,
          6
        ],
        "frameCount": 1,
        "sourceFamily": "animals",
        "sourceCell": [
          7,
          3
        ],
        "sourceCellBounds": [
          1552,
          665,
          1774,
          887
        ],
        "sha256": "3dbbc82f8b58aa2a824634640de4959605b6de2e58253ba6d4d01aaeb3151a70"
      },
      "micro-aircraft-regional-north": {
        "path": "micro-ambient/micro-aircraft-regional-north.png",
        "kind": "aircraft",
        "variant": "regional",
        "direction": "north",
        "size": [
          16,
          16
        ],
        "anchorPx": [
          8,
          8
        ],
        "opaqueBounds": [
          2,
          2,
          14,
          13
        ],
        "frameCount": 1,
        "sourceFamily": "aircraft",
        "sourceCell": [
          0,
          0
        ],
        "sourceCellBounds": [
          0,
          0,
          627,
          627
        ],
        "sha256": "ed36e783a9c3b574283c775cbb153b260e96bf8209e8b05695b8eb118eed7c75"
      },
      "micro-aircraft-regional-east": {
        "path": "micro-ambient/micro-aircraft-regional-east.png",
        "kind": "aircraft",
        "variant": "regional",
        "direction": "east",
        "size": [
          16,
          16
        ],
        "anchorPx": [
          8,
          8
        ],
        "opaqueBounds": [
          2,
          2,
          13,
          14
        ],
        "frameCount": 1,
        "sourceFamily": "aircraft",
        "sourceCell": [
          1,
          0
        ],
        "sourceCellBounds": [
          627,
          0,
          1254,
          627
        ],
        "sha256": "52cdc47a345656b7cdc2ab3b4216173e36e6f14a644b00eb224a1acb79718c52"
      },
      "micro-aircraft-regional-south": {
        "path": "micro-ambient/micro-aircraft-regional-south.png",
        "kind": "aircraft",
        "variant": "regional",
        "direction": "south",
        "size": [
          16,
          16
        ],
        "anchorPx": [
          8,
          8
        ],
        "opaqueBounds": [
          2,
          2,
          14,
          13
        ],
        "frameCount": 1,
        "sourceFamily": "aircraft",
        "sourceCell": [
          0,
          1
        ],
        "sourceCellBounds": [
          0,
          627,
          627,
          1254
        ],
        "sha256": "5a8f1dfd8bc1b9aad17dbe6c6b98ffd5951ba576bd5d514f9ff8ca2480eddf2e"
      },
      "micro-aircraft-regional-west": {
        "path": "micro-ambient/micro-aircraft-regional-west.png",
        "kind": "aircraft",
        "variant": "regional",
        "direction": "west",
        "size": [
          16,
          16
        ],
        "anchorPx": [
          8,
          8
        ],
        "opaqueBounds": [
          2,
          2,
          13,
          14
        ],
        "frameCount": 1,
        "sourceFamily": "aircraft",
        "sourceCell": [
          1,
          1
        ],
        "sourceCellBounds": [
          627,
          627,
          1254,
          1254
        ],
        "sha256": "a4c3ed5d522b600e4ef83b5b0549a9db66e0ec04e8c06a91813e81a60a724d88"
      }
    }
  },
  "atlasClouds": [
    "atlas/clouds-v3/cloud-topdown-1.png",
    "atlas/clouds-v3/cloud-topdown-2.png",
    "atlas/clouds-v3/cloud-topdown-3.png",
    "atlas/clouds-v3/cloud-topdown-4.png"
  ],
  "cityTransport": {
    "schemaVersion": 2,
    "artSource": "AI_AUTHORED",
    "styleProfile": "TASKTOPIA_COMPACT_CARTOON_HIGH_45_V1",
    "sprites": {
      "locomotive-east": {
        "path": "city-transport/locomotive-east.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          0,
          8,
          24,
          16
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          0,
          0,
          443,
          417
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "6e03a7f8b97fd1da36f42a6e14a29b24d635ec1811f47025a9b11741a07dce98"
      },
      "locomotive-north": {
        "path": "city-transport/locomotive-north.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          9,
          0,
          15,
          24
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          0,
          417,
          443,
          940
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "88e1c85d46394496e2cd0c6af6022b921821bceafad694d92625b836b66b7367"
      },
      "locomotive-west": {
        "path": "city-transport/locomotive-west.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          0,
          8,
          24,
          16
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          0,
          940,
          443,
          1171
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "8dd828cec2d5545427f0fa35d4cb8bf2f8a65b07d9a1078fa1a1eddc4bae43c3"
      },
      "locomotive-south": {
        "path": "city-transport/locomotive-south.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          9,
          0,
          15,
          24
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          0,
          1171,
          443,
          1774
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "b00d3d0b014ef4ddb44ee885ed7f943dde1bd35a552c7ae613a2115cf6655bf6"
      },
      "carriage-east": {
        "path": "city-transport/carriage-east.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          0,
          8,
          24,
          16
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          443,
          0,
          887,
          417
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "291fedee52cae3133442989132f00f18d5f1080ef7cf839b55c41e23c3d418bf"
      },
      "carriage-north": {
        "path": "city-transport/carriage-north.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          9,
          0,
          15,
          24
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          443,
          417,
          887,
          940
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "8e823ec027b286e996553642c290442a5ac40a6cadf10dbc49d07776fb361ca7"
      },
      "carriage-west": {
        "path": "city-transport/carriage-west.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          0,
          8,
          24,
          16
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          443,
          940,
          887,
          1171
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "68702739bee8dd382b90da54ee86471b7f6bcad88d9570385fe2c588982206b7"
      },
      "carriage-south": {
        "path": "city-transport/carriage-south.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          9,
          0,
          15,
          24
        ],
        "source": "reference/ai-authored/city-train-v3/sheet.png",
        "sourceRect": [
          443,
          1171,
          887,
          1774
        ],
        "sourceSha256": "21d17d0ddecce85a1026158bca2f36e8650cff1c4435086202d77d84a637608a",
        "sha256": "fbdd03a2c543fe0a12c686ff4e11466335d8ac3288b96e3983e310c89f7838f6"
      },
      "ferry-east": {
        "path": "city-transport/ferry-east.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          5,
          9,
          19,
          15
        ],
        "source": "reference/ai-authored/city-ferry-v1/sheet.png",
        "sourceRect": [
          0,
          0,
          627,
          627
        ],
        "sourceSha256": "03e059938413851ed9a29de6ca0d6a7d6ed655d65b71347db5220bff7a0b0dfa",
        "sha256": "fffd1dc05f92641f2e06d36ffc1f9e5f1954986ecb44cb48090fb6038dccc67d"
      },
      "ferry-north": {
        "path": "city-transport/ferry-north.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          9,
          4,
          15,
          19
        ],
        "source": "reference/ai-authored/city-ferry-v1/sheet.png",
        "sourceRect": [
          627,
          0,
          1254,
          627
        ],
        "sourceSha256": "03e059938413851ed9a29de6ca0d6a7d6ed655d65b71347db5220bff7a0b0dfa",
        "sha256": "b488314bf7f25c512815419618d9d21359bf4abbe38e724dc1a3c0bae0f3b302"
      },
      "ferry-west": {
        "path": "city-transport/ferry-west.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          5,
          9,
          19,
          15
        ],
        "source": "reference/ai-authored/city-ferry-v1/sheet.png",
        "sourceRect": [
          0,
          627,
          627,
          1254
        ],
        "sourceSha256": "03e059938413851ed9a29de6ca0d6a7d6ed655d65b71347db5220bff7a0b0dfa",
        "sha256": "6a97fabb483be485066ad662f55a0a92fe82dde523d3c8f4650dcc88083d98e5"
      },
      "ferry-south": {
        "path": "city-transport/ferry-south.png",
        "size": [
          24,
          24
        ],
        "anchorPx": [
          12,
          12
        ],
        "opaqueBounds": [
          9,
          4,
          15,
          19
        ],
        "source": "reference/ai-authored/city-ferry-v1/sheet.png",
        "sourceRect": [
          627,
          627,
          1254,
          1254
        ],
        "sourceSha256": "03e059938413851ed9a29de6ca0d6a7d6ed655d65b71347db5220bff7a0b0dfa",
        "sha256": "07134ed5138ef15b0046ee1eda5095571d73e50e44e387cd1aee26648ffbe756"
      }
    }
  }
}
